var _construct = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/construct.js").default;

var _classCallCheck2 = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass2 = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createClass.js").default;

var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _toArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toArray.js").default;

var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/core-data"] = t() : (e.wp = e.wp || {}, e.wp.coreData = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      708: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.__experimentalBatch = void 0, t.__experimentalReceiveCurrentGlobalStylesId = function __experimentalReceiveCurrentGlobalStylesId(e) {
          return {
            type: "RECEIVE_CURRENT_GLOBAL_STYLES_ID",
            id: e
          };
        }, t.__experimentalReceiveThemeBaseGlobalStyles = function __experimentalReceiveThemeBaseGlobalStyles(e, t) {
          return {
            type: "RECEIVE_THEME_GLOBAL_STYLES",
            stylesheet: e,
            globalStyles: t
          };
        }, t.__experimentalSaveSpecifiedEntityEdits = void 0, t.__unstableCreateUndoLevel = function __unstableCreateUndoLevel() {
          return {
            type: "CREATE_UNDO_LEVEL"
          };
        }, t.addEntities = function addEntities(e) {
          return {
            type: "ADD_ENTITIES",
            entities: e
          };
        }, t.editEntityRecord = t.deleteEntityRecord = void 0, t.receiveAutosaves = function receiveAutosaves(e, t) {
          return {
            type: "RECEIVE_AUTOSAVES",
            postId: e,
            autosaves: (0, i.castArray)(t)
          };
        }, t.receiveCurrentTheme = function receiveCurrentTheme(e) {
          return {
            type: "RECEIVE_CURRENT_THEME",
            currentTheme: e
          };
        }, t.receiveCurrentUser = function receiveCurrentUser(e) {
          return {
            type: "RECEIVE_CURRENT_USER",
            currentUser: e
          };
        }, t.receiveEmbedPreview = function receiveEmbedPreview(e, t) {
          return {
            type: "RECEIVE_EMBED_PREVIEW",
            url: e,
            preview: t
          };
        }, t.receiveEntityRecords = function receiveEntityRecords(e, t, r, n) {
          var s,
              a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
              o = arguments.length > 5 ? arguments[5] : void 0;
          "postType" === e && (r = (0, i.castArray)(r).map(function (e) {
            return "auto-draft" === e.status ? _objectSpread(_objectSpread({}, e), {}, {
              title: ""
            }) : e;
          }));
          s = n ? (0, d.receiveQueriedItems)(r, n, o) : (0, d.receiveItems)(r, o);
          return _objectSpread(_objectSpread({}, s), {}, {
            kind: e,
            name: t,
            invalidateCache: a
          });
        }, t.receiveThemeSupports = function receiveThemeSupports() {
          return (0, u.default)("wp.data.dispatch( 'core' ).receiveThemeSupports", {
            since: "5.9"
          }), {
            type: "DO_NOTHING"
          };
        }, t.receiveUploadPermissions = function receiveUploadPermissions(e) {
          return {
            type: "RECEIVE_USER_PERMISSION",
            key: "create/media",
            isAllowed: e
          };
        }, t.receiveUserPermission = function receiveUserPermission(e, t) {
          return {
            type: "RECEIVE_USER_PERMISSION",
            key: e,
            isAllowed: t
          };
        }, t.receiveUserQuery = function receiveUserQuery(e, t) {
          return {
            type: "RECEIVE_USER_QUERY",
            users: (0, i.castArray)(t),
            queryID: e
          };
        }, t.undo = t.saveEntityRecord = t.saveEditedEntityRecord = t.redo = void 0;
        var i = r(793),
            s = r(233),
            a = n(r(507)),
            o = r(904),
            u = n(r(703)),
            d = r(366),
            l = r(85),
            c = r(539),
            p = r(971);

        t.deleteEntityRecord = function (e, t, r, n) {
          var _ref = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {},
              _ref$__unstableFetch = _ref.__unstableFetch,
              s = _ref$__unstableFetch === void 0 ? a.default : _ref$__unstableFetch;

          return /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a) {
              var u, c, v, y, E, m, _i;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      u = a.dispatch;
                      _context.next = 3;
                      return u((0, l.getKindEntities)(e));

                    case 3:
                      c = _context.sent;
                      v = (0, i.find)(c, {
                        kind: e,
                        name: t
                      });
                      E = !1;

                      if (!(!v || null != v && v.__experimentalNoFetch)) {
                        _context.next = 8;
                        break;
                      }

                      return _context.abrupt("return");

                    case 8:
                      _context.next = 10;
                      return u.__unstableAcquireStoreLock(p.STORE_NAME, ["entities", "data", e, t, r], {
                        exclusive: !0
                      });

                    case 10:
                      m = _context.sent;
                      _context.prev = 11;
                      u({
                        type: "DELETE_ENTITY_RECORD_START",
                        kind: e,
                        name: t,
                        recordId: r
                      });
                      _context.prev = 13;
                      _i = "".concat(v.baseURL, "/").concat(r);
                      n && (_i = (0, o.addQueryArgs)(_i, n));
                      _context.next = 18;
                      return s({
                        path: _i,
                        method: "DELETE"
                      });

                    case 18:
                      E = _context.sent;
                      _context.next = 21;
                      return u((0, d.removeItems)(e, t, r, !0));

                    case 21:
                      _context.next = 26;
                      break;

                    case 23:
                      _context.prev = 23;
                      _context.t0 = _context["catch"](13);
                      y = _context.t0;

                    case 26:
                      return _context.abrupt("return", (u({
                        type: "DELETE_ENTITY_RECORD_FINISH",
                        kind: e,
                        name: t,
                        recordId: r,
                        error: y
                      }), E));

                    case 27:
                      _context.prev = 27;

                      u.__unstableReleaseStoreLock(m);

                      return _context.finish(27);

                    case 30:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[11,, 27, 30], [13, 23]]);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }();
        };

        t.editEntityRecord = function (e, t, r, n) {
          var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
          return function (a) {
            var o = a.select,
                u = a.dispatch;
            var d = o.getEntity(e, t);
            if (!d) throw new Error("The entity being edited (".concat(e, ", ").concat(t, ") does not have a loaded config."));
            var _d$transientEdits = d.transientEdits,
                l = _d$transientEdits === void 0 ? {} : _d$transientEdits,
                _d$mergedEdits = d.mergedEdits,
                c = _d$mergedEdits === void 0 ? {} : _d$mergedEdits,
                p = o.getRawEntityRecord(e, t, r),
                v = o.getEditedEntityRecord(e, t, r),
                y = {
              kind: e,
              name: t,
              recordId: r,
              edits: Object.keys(n).reduce(function (e, t) {
                var r = p[t],
                    s = v[t],
                    a = c[t] ? _objectSpread(_objectSpread({}, s), n[t]) : n[t];
                return e[t] = (0, i.isEqual)(r, a) ? void 0 : a, e;
              }, {}),
              transientEdits: l
            };
            u(_objectSpread(_objectSpread({
              type: "EDIT_ENTITY_RECORD"
            }, y), {}, {
              meta: {
                undo: !s.undoIgnore && _objectSpread(_objectSpread({}, y), {}, {
                  edits: Object.keys(n).reduce(function (e, t) {
                    return e[t] = v[t], e;
                  }, {})
                })
              }
            }));
          };
        };

        t.undo = function () {
          return function (e) {
            var t = e.select,
                r = e.dispatch;
            var n = t.getUndoEdit();
            n && r(_objectSpread(_objectSpread({
              type: "EDIT_ENTITY_RECORD"
            }, n), {}, {
              meta: {
                isUndo: !0
              }
            }));
          };
        };

        t.redo = function () {
          return function (e) {
            var t = e.select,
                r = e.dispatch;
            var n = t.getRedoEdit();
            n && r(_objectSpread(_objectSpread({
              type: "EDIT_ENTITY_RECORD"
            }, n), {}, {
              meta: {
                isRedo: !0
              }
            }));
          };
        };

        t.saveEntityRecord = function (e, t, r) {
          var _ref3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              _ref3$isAutosave = _ref3.isAutosave,
              n = _ref3$isAutosave === void 0 ? !1 : _ref3$isAutosave,
              _ref3$__unstableFetch = _ref3.__unstableFetch,
              o = _ref3$__unstableFetch === void 0 ? a.default : _ref3$__unstableFetch;

          return /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(a) {
              var u, d, c, v, y, E, m, g, _i3, _Object$entries, _Object$entries$_i, _n, _i4, _s2, _i2, _s, _s3, _a, _n2, _l, _p, _v, _r, _n3;

              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      u = a.select, d = a.resolveSelect, c = a.dispatch;
                      _context2.next = 3;
                      return c((0, l.getKindEntities)(e));

                    case 3:
                      v = _context2.sent;
                      y = (0, i.find)(v, {
                        kind: e,
                        name: t
                      });

                      if (!(!y || null != y && y.__experimentalNoFetch)) {
                        _context2.next = 7;
                        break;
                      }

                      return _context2.abrupt("return");

                    case 7:
                      E = y.key || l.DEFAULT_ENTITY_KEY;
                      m = r[E];
                      _context2.next = 11;
                      return c.__unstableAcquireStoreLock(p.STORE_NAME, ["entities", "data", e, t, m || (0, s.v4)()], {
                        exclusive: !0
                      });

                    case 11:
                      g = _context2.sent;
                      _context2.prev = 12;

                      for (_i3 = 0, _Object$entries = Object.entries(r); _i3 < _Object$entries.length; _i3++) {
                        _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2), _n = _Object$entries$_i[0], _i4 = _Object$entries$_i[1];

                        if ("function" == typeof _i4) {
                          _s2 = _i4(u.getEditedEntityRecord(e, t, m));
                          c.editEntityRecord(e, t, m, _defineProperty({}, _n, _s2), {
                            undoIgnore: !0
                          }), r[_n] = _s2;
                        }
                      }

                      c({
                        type: "SAVE_ENTITY_RECORD_START",
                        kind: e,
                        name: t,
                        recordId: m,
                        isAutosave: n
                      });
                      _context2.prev = 15;
                      _s3 = "".concat(y.baseURL).concat(m ? "/" + m : ""), _a = u.getRawEntityRecord(e, t, m);

                      if (!n) {
                        _context2.next = 32;
                        break;
                      }

                      _n2 = u.getCurrentUser(), _l = _n2 ? _n2.id : void 0, _p = d.getAutosave(_a.type, _a.id, _l);
                      _v = _objectSpread(_objectSpread(_objectSpread({}, _a), _p), r);
                      _v = Object.keys(_v).reduce(function (e, t) {
                        return ["title", "excerpt", "content"].includes(t) && (e[t] = _v[t]), e;
                      }, {
                        status: "auto-draft" === _v.status ? "draft" : _v.status
                      });
                      _context2.next = 23;
                      return o({
                        path: "".concat(_s3, "/autosaves"),
                        method: "POST",
                        data: _v
                      });

                    case 23:
                      _i2 = _context2.sent;

                      if (!(_a.id === _i2.id)) {
                        _context2.next = 29;
                        break;
                      }

                      _r = _objectSpread(_objectSpread(_objectSpread({}, _a), _v), _i2);
                      _r = Object.keys(_r).reduce(function (e, t) {
                        return ["title", "excerpt", "content"].includes(t) ? e[t] = _r[t] : e[t] = "status" === t ? "auto-draft" === _a.status && "draft" === _r.status ? _r.status : _a.status : _a[t], e;
                      }, {}), c.receiveEntityRecords(e, t, _r, void 0, !0);
                      _context2.next = 30;
                      break;

                    case 29:
                      c.receiveAutosaves(_a.id, _i2);

                    case 30:
                      _context2.next = 38;
                      break;

                    case 32:
                      _n3 = r;
                      y.__unstablePrePersist && (_n3 = _objectSpread(_objectSpread({}, _n3), y.__unstablePrePersist(_a, _n3)));
                      _context2.next = 36;
                      return o({
                        path: _s3,
                        method: m ? "PUT" : "POST",
                        data: _n3
                      });

                    case 36:
                      _i2 = _context2.sent;
                      c.receiveEntityRecords(e, t, _i2, void 0, !0, _n3);

                    case 38:
                      _context2.next = 43;
                      break;

                    case 40:
                      _context2.prev = 40;
                      _context2.t0 = _context2["catch"](15);
                      _s = _context2.t0;

                    case 43:
                      return _context2.abrupt("return", (c({
                        type: "SAVE_ENTITY_RECORD_FINISH",
                        kind: e,
                        name: t,
                        recordId: m,
                        error: _s,
                        isAutosave: n
                      }), _i2));

                    case 44:
                      _context2.prev = 44;

                      c.__unstableReleaseStoreLock(g);

                      return _context2.finish(44);

                    case 47:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[12,, 44, 47], [15, 40]]);
            }));

            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }();
        };

        t.__experimentalBatch = function (e) {
          return /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
              var r, n, i, s, _yield$Promise$all, _yield$Promise$all2, a;

              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      r = t.dispatch;
                      n = (0, c.createBatch)();
                      i = {
                        saveEntityRecord: function saveEntityRecord(e, t, i, s) {
                          return n.add(function (n) {
                            return r.saveEntityRecord(e, t, i, _objectSpread(_objectSpread({}, s), {}, {
                              __unstableFetch: n
                            }));
                          });
                        },
                        saveEditedEntityRecord: function saveEditedEntityRecord(e, t, i, s) {
                          return n.add(function (n) {
                            return r.saveEditedEntityRecord(e, t, i, _objectSpread(_objectSpread({}, s), {}, {
                              __unstableFetch: n
                            }));
                          });
                        },
                        deleteEntityRecord: function deleteEntityRecord(e, t, i, s, a) {
                          return n.add(function (n) {
                            return r.deleteEntityRecord(e, t, i, s, _objectSpread(_objectSpread({}, a), {}, {
                              __unstableFetch: n
                            }));
                          });
                        }
                      };
                      s = e.map(function (e) {
                        return e(i);
                      });
                      _context3.next = 6;
                      return Promise.all([n.run()].concat(_toConsumableArray(s)));

                    case 6:
                      _yield$Promise$all = _context3.sent;
                      _yield$Promise$all2 = _toArray(_yield$Promise$all);
                      a = _yield$Promise$all2.slice(1);
                      return _context3.abrupt("return", a);

                    case 10:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref5.apply(this, arguments);
            };
          }();
        };

        t.saveEditedEntityRecord = function (e, t, r, n) {
          return /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(s) {
              var a, o, u, d, c, p, v;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      a = s.select, o = s.dispatch;

                      if (a.hasEditsForEntityRecord(e, t, r)) {
                        _context4.next = 3;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 3:
                      _context4.next = 5;
                      return o((0, l.getKindEntities)(e));

                    case 5:
                      u = _context4.sent;
                      d = (0, i.find)(u, {
                        kind: e,
                        name: t
                      });

                      if (d) {
                        _context4.next = 9;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 9:
                      c = d.key || l.DEFAULT_ENTITY_KEY, p = a.getEntityRecordNonTransientEdits(e, t, r), v = _objectSpread(_defineProperty({}, c, r), p);
                      _context4.next = 12;
                      return o.saveEntityRecord(e, t, v, n);

                    case 12:
                      return _context4.abrupt("return", _context4.sent);

                    case 13:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x4) {
              return _ref6.apply(this, arguments);
            };
          }();
        };

        t.__experimentalSaveSpecifiedEntityEdits = function (e, t, r, n, i) {
          return /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(s) {
              var a, o, u, d, _loop, _e;

              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      a = s.select, o = s.dispatch;

                      if (a.hasEditsForEntityRecord(e, t, r)) {
                        _context5.next = 3;
                        break;
                      }

                      return _context5.abrupt("return");

                    case 3:
                      u = a.getEntityRecordNonTransientEdits(e, t, r), d = {};

                      _loop = function _loop(_e) {
                        n.some(function (t) {
                          return t === _e;
                        }) && (d[_e] = u[_e]);
                      };

                      for (_e in u) {
                        _loop(_e);
                      }

                      _context5.next = 8;
                      return o.saveEntityRecord(e, t, d, i);

                    case 8:
                      return _context5.abrupt("return", _context5.sent);

                    case 9:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }));

            return function (_x5) {
              return _ref7.apply(this, arguments);
            };
          }();
        };
      },
      575: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function createBatch() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s.default,
              t = 0,
              r = [];
          var n = new ObservableSet();
          return {
            add: function add(e) {
              var s = ++t;
              n.add(s);

              var add = function add(e) {
                return new Promise(function (t, i) {
                  r.push({
                    input: e,
                    resolve: t,
                    reject: i
                  }), n.delete(s);
                });
              };

              return (0, i.isFunction)(e) ? Promise.resolve(e(add)).finally(function () {
                n.delete(s);
              }) : add(e);
            },
            run: function run() {
              return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var t, _iterator, _step, _t, s, _iterator2, _step2, _step2$value, _e2, _step2$value$, _n4, o, a;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.t0 = n.size;

                        if (!_context6.t0) {
                          _context6.next = 4;
                          break;
                        }

                        _context6.next = 4;
                        return new Promise(function (e) {
                          var t = n.subscribe(function () {
                            n.size || (t(), e());
                          });
                        });

                      case 4:
                        _context6.prev = 4;
                        _context6.next = 7;
                        return e(r.map(function (e) {
                          var t = e.input;
                          return t;
                        }));

                      case 7:
                        t = _context6.sent;

                        if (!(t.length !== r.length)) {
                          _context6.next = 10;
                          break;
                        }

                        throw new Error("run: Array returned by processor must be same size as input array.");

                      case 10:
                        _context6.next = 17;
                        break;

                      case 12:
                        _context6.prev = 12;
                        _context6.t1 = _context6["catch"](4);
                        _iterator = _createForOfIteratorHelper(r);

                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            _t = _step.value.reject;

                            _t(_context6.t1);
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }

                        throw _context6.t1;

                      case 17:
                        s = !0;
                        _iterator2 = _createForOfIteratorHelper((0, i.zip)(t, r));

                        try {
                          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            _step2$value = _slicedToArray(_step2.value, 2), _e2 = _step2$value[0], _step2$value$ = _step2$value[1], _n4 = _step2$value$.resolve, o = _step2$value$.reject;
                            if (null != _e2 && _e2.error) o(_e2.error), s = !1;else _n4(null !== (a = null == _e2 ? void 0 : _e2.output) && void 0 !== a ? a : _e2);
                          }
                        } catch (err) {
                          _iterator2.e(err);
                        } finally {
                          _iterator2.f();
                        }

                        return _context6.abrupt("return", (r = [], s));

                      case 21:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, null, [[4, 12]]);
              }))();
            }
          };
        };
        var i = r(793),
            s = n(r(734));

        var ObservableSet = /*#__PURE__*/function () {
          function ObservableSet() {
            _classCallCheck2(this, ObservableSet);

            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            this.set = _construct(Set, t), this.subscribers = new Set();
          }

          _createClass2(ObservableSet, [{
            key: "size",
            get: function get() {
              return this.set.size;
            }
          }, {
            key: "add",
            value: function add() {
              var _this$set;

              return (_this$set = this.set).add.apply(_this$set, arguments), this.subscribers.forEach(function (e) {
                return e();
              }), this;
            }
          }, {
            key: "delete",
            value: function _delete() {
              var _this$set2;

              var e = (_this$set2 = this.set).delete.apply(_this$set2, arguments);

              return this.subscribers.forEach(function (e) {
                return e();
              }), e;
            }
          }, {
            key: "subscribe",
            value: function subscribe(e) {
              var _this = this;

              return this.subscribers.add(e), function () {
                _this.subscribers.delete(e);
              };
            }
          }]);

          return ObservableSet;
        }();
      },
      734: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = /*#__PURE__*/function () {
          var _defaultProcessor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
            var _e3, t, _iterator3, _step3, _r2, _e4, _n5;

            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!(null === a)) {
                      _context7.next = 5;
                      break;
                    }

                    _context7.next = 3;
                    return (0, s.default)({
                      path: "/batch/v1",
                      method: "OPTIONS"
                    });

                  case 3:
                    _e3 = _context7.sent;
                    a = _e3.endpoints[0].args.requests.maxItems;

                  case 5:
                    t = [];
                    _iterator3 = _createForOfIteratorHelper((0, i.chunk)(e, a));
                    _context7.prev = 7;

                    _iterator3.s();

                  case 9:
                    if ((_step3 = _iterator3.n()).done) {
                      _context7.next = 18;
                      break;
                    }

                    _r2 = _step3.value;
                    _context7.next = 13;
                    return (0, s.default)({
                      path: "/batch/v1",
                      method: "POST",
                      data: {
                        validation: "require-all-validate",
                        requests: _r2.map(function (e) {
                          return {
                            path: e.path,
                            body: e.data,
                            method: e.method,
                            headers: e.headers
                          };
                        })
                      }
                    });

                  case 13:
                    _e4 = _context7.sent;
                    _n5 = void 0;
                    _n5 = _e4.failed ? _e4.responses.map(function (e) {
                      return {
                        error: null == e ? void 0 : e.body
                      };
                    }) : _e4.responses.map(function (e) {
                      var t = {};
                      return e.status >= 200 && e.status < 300 ? t.output = e.body : t.error = e.body, t;
                    }), t.push.apply(t, _toConsumableArray(_n5));

                  case 16:
                    _context7.next = 9;
                    break;

                  case 18:
                    _context7.next = 23;
                    break;

                  case 20:
                    _context7.prev = 20;
                    _context7.t0 = _context7["catch"](7);

                    _iterator3.e(_context7.t0);

                  case 23:
                    _context7.prev = 23;

                    _iterator3.f();

                    return _context7.finish(23);

                  case 26:
                    return _context7.abrupt("return", t);

                  case 27:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, null, [[7, 20, 23, 26]]);
          }));

          function defaultProcessor(_x6) {
            return _defaultProcessor.apply(this, arguments);
          }

          return defaultProcessor;
        }();
        var i = r(793),
            s = n(r(507));
        var a = null;
      },
      539: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "createBatch", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        }), Object.defineProperty(t, "defaultProcessor", {
          enumerable: !0,
          get: function get() {
            return s.default;
          }
        });
        var i = n(r(575)),
            s = n(r(734));
      },
      85: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prePersistPostType = t.kinds = t.getMethodName = t.getKindEntities = t.defaultEntities = t.DEFAULT_ENTITY_KEY = void 0;
        var i = r(793),
            s = n(r(507)),
            a = r(756),
            o = r(708);
        t.DEFAULT_ENTITY_KEY = "id";
        var u = ["title", "excerpt", "content"],
            d = [{
          label: (0, a.__)("Base"),
          name: "__unstableBase",
          kind: "root",
          baseURL: "/"
        }, {
          label: (0, a.__)("Site"),
          name: "site",
          kind: "root",
          baseURL: "/wp/v2/settings",
          getTitle: function getTitle(e) {
            return (0, i.get)(e, ["title"], (0, a.__)("Site Title"));
          }
        }, {
          label: (0, a.__)("Post Type"),
          name: "postType",
          kind: "root",
          key: "slug",
          baseURL: "/wp/v2/types",
          baseURLParams: {
            context: "edit"
          },
          rawAttributes: u
        }, {
          name: "media",
          kind: "root",
          baseURL: "/wp/v2/media",
          baseURLParams: {
            context: "edit"
          },
          plural: "mediaItems",
          label: (0, a.__)("Media")
        }, {
          name: "taxonomy",
          kind: "root",
          key: "slug",
          baseURL: "/wp/v2/taxonomies",
          baseURLParams: {
            context: "edit"
          },
          plural: "taxonomies",
          label: (0, a.__)("Taxonomy")
        }, {
          name: "sidebar",
          kind: "root",
          baseURL: "/wp/v2/sidebars",
          plural: "sidebars",
          transientEdits: {
            blocks: !0
          },
          label: (0, a.__)("Widget areas")
        }, {
          name: "widget",
          kind: "root",
          baseURL: "/wp/v2/widgets",
          baseURLParams: {
            context: "edit"
          },
          plural: "widgets",
          transientEdits: {
            blocks: !0
          },
          label: (0, a.__)("Widgets")
        }, {
          name: "widgetType",
          kind: "root",
          baseURL: "/wp/v2/widget-types",
          baseURLParams: {
            context: "edit"
          },
          plural: "widgetTypes",
          label: (0, a.__)("Widget types")
        }, {
          label: (0, a.__)("User"),
          name: "user",
          kind: "root",
          baseURL: "/wp/v2/users",
          baseURLParams: {
            context: "edit"
          },
          plural: "users"
        }, {
          name: "comment",
          kind: "root",
          baseURL: "/wp/v2/comments",
          baseURLParams: {
            context: "edit"
          },
          plural: "comments",
          label: (0, a.__)("Comment")
        }, {
          name: "menu",
          kind: "root",
          baseURL: "/wp/v2/menus",
          baseURLParams: {
            context: "edit"
          },
          plural: "menus",
          label: (0, a.__)("Menu")
        }, {
          name: "menuItem",
          kind: "root",
          baseURL: "/wp/v2/menu-items",
          baseURLParams: {
            context: "edit"
          },
          plural: "menuItems",
          label: (0, a.__)("Menu Item"),
          rawAttributes: ["title", "content"]
        }, {
          name: "menuLocation",
          kind: "root",
          baseURL: "/wp/v2/menu-locations",
          baseURLParams: {
            context: "edit"
          },
          plural: "menuLocations",
          label: (0, a.__)("Menu Location"),
          key: "name"
        }, {
          name: "navigationArea",
          kind: "root",
          baseURL: "/wp/v2/block-navigation-areas",
          baseURLParams: {
            context: "edit"
          },
          plural: "navigationAreas",
          label: (0, a.__)("Navigation Area"),
          key: "name",
          getTitle: function getTitle(e) {
            return null == e ? void 0 : e.description;
          }
        }, {
          label: (0, a.__)("Global Styles"),
          name: "globalStyles",
          kind: "root",
          baseURL: "/wp/v2/global-styles",
          baseURLParams: {
            context: "edit"
          },
          plural: "globalStylesVariations",
          getTitle: function getTitle(e) {
            var t;
            return (null == e || null === (t = e.title) || void 0 === t ? void 0 : t.rendered) || (null == e ? void 0 : e.title);
          }
        }, {
          label: (0, a.__)("Themes"),
          name: "theme",
          kind: "root",
          baseURL: "/wp/v2/themes",
          baseURLParams: {
            context: "edit"
          },
          key: "stylesheet"
        }, {
          label: (0, a.__)("Plugins"),
          name: "plugin",
          kind: "root",
          baseURL: "/wp/v2/plugins",
          baseURLParams: {
            context: "edit"
          },
          key: "plugin"
        }];
        t.defaultEntities = d;
        var l = [{
          name: "postType",
          loadEntities: function () {
            var _loadPostTypeEntities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
              var e;
              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      _context8.next = 2;
                      return (0, s.default)({
                        path: "/wp/v2/types?context=edit"
                      });

                    case 2:
                      e = _context8.sent;
                      return _context8.abrupt("return", (0, i.map)(e, function (e, t) {
                        var r;
                        var n = ["wp_template", "wp_template_part"].includes(t);
                        return {
                          kind: "postType",
                          baseURL: "/".concat(null !== (r = null == e ? void 0 : e.rest_namespace) && void 0 !== r ? r : "wp/v2", "/").concat(e.rest_base),
                          baseURLParams: {
                            context: "edit"
                          },
                          name: t,
                          label: e.labels.singular_name,
                          transientEdits: {
                            blocks: !0,
                            selection: !0
                          },
                          mergedEdits: {
                            meta: !0
                          },
                          rawAttributes: u,
                          getTitle: function getTitle(e) {
                            var t;
                            return (null == e || null === (t = e.title) || void 0 === t ? void 0 : t.rendered) || (null == e ? void 0 : e.title) || (n ? (0, i.startCase)(e.slug) : String(e.id));
                          },
                          __unstablePrePersist: n ? void 0 : prePersistPostType,
                          __unstable_rest_base: e.rest_base
                        };
                      }));

                    case 4:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8);
            }));

            function loadPostTypeEntities() {
              return _loadPostTypeEntities.apply(this, arguments);
            }

            return loadPostTypeEntities;
          }()
        }, {
          name: "taxonomy",
          loadEntities: function () {
            var _loadTaxonomyEntities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
              var e;
              return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                  switch (_context9.prev = _context9.next) {
                    case 0:
                      _context9.next = 2;
                      return (0, s.default)({
                        path: "/wp/v2/taxonomies?context=edit"
                      });

                    case 2:
                      e = _context9.sent;
                      return _context9.abrupt("return", (0, i.map)(e, function (e, t) {
                        var r;
                        return {
                          kind: "taxonomy",
                          baseURL: "/".concat(null !== (r = null == e ? void 0 : e.rest_namespace) && void 0 !== r ? r : "wp/v2", "/").concat(e.rest_base),
                          baseURLParams: {
                            context: "edit"
                          },
                          name: t,
                          label: e.labels.singular_name
                        };
                      }));

                    case 4:
                    case "end":
                      return _context9.stop();
                  }
                }
              }, _callee9);
            }));

            function loadTaxonomyEntities() {
              return _loadTaxonomyEntities.apply(this, arguments);
            }

            return loadTaxonomyEntities;
          }()
        }];
        t.kinds = l;

        var prePersistPostType = function prePersistPostType(e, t) {
          var r = {};
          return "auto-draft" === (null == e ? void 0 : e.status) && (t.status || r.status || (r.status = "draft"), t.title && "Auto Draft" !== t.title || r.title || null != e && e.title && "Auto Draft" !== (null == e ? void 0 : e.title) || (r.title = "")), r;
        };

        t.prePersistPostType = prePersistPostType;

        t.getMethodName = function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "get",
              n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          var s = (0, i.find)(d, {
            kind: e,
            name: t
          }),
              a = "root" === e ? "" : (0, i.upperFirst)((0, i.camelCase)(e)),
              o = (0, i.upperFirst)((0, i.camelCase)(t)) + (n ? "s" : ""),
              u = n && s.plural ? (0, i.upperFirst)((0, i.camelCase)(s.plural)) : o;
          return "".concat(r).concat(a).concat(u);
        };

        t.getKindEntities = function (e) {
          return /*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t) {
              var r, n, s, a;
              return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                  switch (_context10.prev = _context10.next) {
                    case 0:
                      r = t.select, n = t.dispatch, s = r.getEntitiesByKind(e);

                      if (!(s && 0 !== s.length)) {
                        _context10.next = 3;
                        break;
                      }

                      return _context10.abrupt("return", s);

                    case 3:
                      a = (0, i.find)(l, {
                        name: e
                      });

                      if (!a) {
                        _context10.next = 12;
                        break;
                      }

                      _context10.next = 7;
                      return a.loadEntities();

                    case 7:
                      s = _context10.sent;
                      n((0, o.addEntities)(s));
                      _context10.t0 = s;
                      _context10.next = 13;
                      break;

                    case 12:
                      _context10.t0 = [];

                    case 13:
                      return _context10.abrupt("return", _context10.t0);

                    case 14:
                    case "end":
                      return _context10.stop();
                  }
                }
              }, _callee10);
            }));

            return function (_x7) {
              return _ref8.apply(this, arguments);
            };
          }();
        };
      },
      374: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function EntityProvider(e) {
          var t = e.kind,
              r = e.type,
              i = e.id,
              s = e.children;
          var a = getEntity(t, r).context.Provider;
          return (0, n.createElement)(a, {
            value: i
          }, s);
        }, t.useEntityBlockEditor = function useEntityBlockEditor(e, t) {
          var _ref9 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = _ref9.id;

          var o = useEntityId(e, t),
              d = null != r ? r : o,
              _ref10 = (0, i.useSelect)(function (r) {
            var _r3 = r(a.STORE_NAME),
                n = _r3.getEditedEntityRecord,
                i = n(e, t, d);

            return {
              blocks: i.blocks,
              content: i.content
            };
          }, [e, t, d]),
              l = _ref10.content,
              c = _ref10.blocks,
              _ref11 = (0, i.useDispatch)(a.STORE_NAME),
              p = _ref11.__unstableCreateUndoLevel,
              v = _ref11.editEntityRecord;

          (0, n.useEffect)(function () {
            if (l && "function" != typeof l && !c) {
              var _r4 = (0, s.parse)(l);

              v(e, t, d, {
                blocks: _r4
              }, {
                undoIgnore: !0
              });
            }
          }, [l]);
          var y = (0, n.useCallback)(function (r, n) {
            var i = n.selection,
                a = {
              blocks: r,
              selection: i
            };
            if (c === a.blocks) return p(e, t, d);
            a.content = function (e) {
              var _e$blocks = e.blocks,
                  t = _e$blocks === void 0 ? [] : _e$blocks;
              return (0, s.__unstableSerializeAndClean)(t);
            }, v(e, t, d, a);
          }, [e, t, d, c]),
              E = (0, n.useCallback)(function (r, n) {
            var i = n.selection;
            v(e, t, d, {
              blocks: r,
              selection: i
            });
          }, [e, t, d]);
          return [null != c ? c : u, E, y];
        }, t.useEntityId = useEntityId, t.useEntityProp = function useEntityProp(e, t, r, s) {
          var o = useEntityId(e, t),
              u = null != s ? s : o,
              _ref12 = (0, i.useSelect)(function (n) {
            var _n6 = n(a.STORE_NAME),
                i = _n6.getEntityRecord,
                s = _n6.getEditedEntityRecord,
                o = i(e, t, u),
                d = s(e, t, u);

            return o && d ? {
              value: d[r],
              fullValue: o[r]
            } : {};
          }, [e, t, u, r]),
              d = _ref12.value,
              l = _ref12.fullValue,
              _ref13 = (0, i.useDispatch)(a.STORE_NAME),
              c = _ref13.editEntityRecord,
              p = (0, n.useCallback)(function (n) {
            c(e, t, u, _defineProperty({}, r, n));
          }, [e, t, u, r]);

          return [d, p, l];
        };
        var n = r(753),
            i = r(467),
            s = r(700),
            a = r(971),
            o = r(85);

        var u = [],
            d = _objectSpread(_objectSpread({}, o.defaultEntities.reduce(function (e, t) {
          return e[t.kind] || (e[t.kind] = {}), e[t.kind][t.name] = {
            context: (0, n.createContext)()
          }, e;
        }, {})), o.kinds.reduce(function (e, t) {
          return e[t.name] = {}, e;
        }, {})),
            getEntity = function getEntity(e, t) {
          if (!d[e]) throw new Error("Missing entity config for kind: ".concat(e, "."));
          return d[e][t] || (d[e][t] = {
            context: (0, n.createContext)()
          }), d[e][t];
        };

        function useEntityId(e, t) {
          return (0, n.useContext)(getEntity(e, t).context);
        }
      },
      943: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var i = n(r(507)),
            s = r(904),
            a = r(248),
            o = r(756);

        var _default = /*#__PURE__*/function () {
          var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
            var t,
                r,
                _t$isInitialSuggestio,
                n,
                u,
                d,
                l,
                _t$perPage,
                c,
                _r$disablePostFormats,
                p,
                v,
                _args11 = arguments;

            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    t = _args11.length > 1 && void 0 !== _args11[1] ? _args11[1] : {}, r = _args11.length > 2 && void 0 !== _args11[2] ? _args11[2] : {};
                    _t$isInitialSuggestio = t.isInitialSuggestions, n = _t$isInitialSuggestio === void 0 ? !1 : _t$isInitialSuggestio, u = t.type, d = t.subtype, l = t.page, _t$perPage = t.perPage, c = _t$perPage === void 0 ? n ? 3 : 20 : _t$perPage, _r$disablePostFormats = r.disablePostFormats, p = _r$disablePostFormats === void 0 ? !1 : _r$disablePostFormats, v = [];
                    return _context11.abrupt("return", (u && "post" !== u || v.push((0, i.default)({
                      path: (0, s.addQueryArgs)("/wp/v2/search", {
                        search: e,
                        page: l,
                        per_page: c,
                        type: "post",
                        subtype: d
                      })
                    }).then(function (e) {
                      return e.map(function (e) {
                        return _objectSpread(_objectSpread({}, e), {}, {
                          meta: {
                            kind: "post-type",
                            subtype: d
                          }
                        });
                      });
                    }).catch(function () {
                      return [];
                    })), u && "term" !== u || v.push((0, i.default)({
                      path: (0, s.addQueryArgs)("/wp/v2/search", {
                        search: e,
                        page: l,
                        per_page: c,
                        type: "term",
                        subtype: d
                      })
                    }).then(function (e) {
                      return e.map(function (e) {
                        return _objectSpread(_objectSpread({}, e), {}, {
                          meta: {
                            kind: "taxonomy",
                            subtype: d
                          }
                        });
                      });
                    }).catch(function () {
                      return [];
                    })), p || u && "post-format" !== u || v.push((0, i.default)({
                      path: (0, s.addQueryArgs)("/wp/v2/search", {
                        search: e,
                        page: l,
                        per_page: c,
                        type: "post-format",
                        subtype: d
                      })
                    }).then(function (e) {
                      return e.map(function (e) {
                        return _objectSpread(_objectSpread({}, e), {}, {
                          meta: {
                            kind: "taxonomy",
                            subtype: d
                          }
                        });
                      });
                    }).catch(function () {
                      return [];
                    })), Promise.all(v).then(function (e) {
                      return e.reduce(function (e, t) {
                        return e.concat(t);
                      }, []).filter(function (e) {
                        return !!e.id;
                      }).slice(0, c).map(function (e) {
                        var t;
                        return {
                          id: e.id,
                          url: e.url,
                          title: (0, a.decodeEntities)(e.title || "") || (0, o.__)("(no title)"),
                          type: e.subtype || e.type,
                          kind: null == e || null === (t = e.meta) || void 0 === t ? void 0 : t.kind
                        };
                      });
                    })));

                  case 3:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11);
          }));

          return function _default(_x8) {
            return _ref14.apply(this, arguments);
          };
        }();

        t.default = _default;
      },
      46: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var i = n(r(507)),
            s = r(904);
        var a = new Map();

        var _default = /*#__PURE__*/function () {
          var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
            var t,
                r,
                n,
                o,
                _args12 = arguments;
            return _regeneratorRuntime.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    t = _args12.length > 1 && void 0 !== _args12[1] ? _args12[1] : {};
                    r = "/wp-block-editor/v1/url-details", n = {
                      url: (0, s.prependHTTP)(e)
                    };

                    if ((0, s.isURL)(e)) {
                      _context12.next = 4;
                      break;
                    }

                    return _context12.abrupt("return", Promise.reject("".concat(e, " is not a valid URL.")));

                  case 4:
                    o = (0, s.getProtocol)(e);
                    return _context12.abrupt("return", (0, s.isValidProtocol)(o) && o.startsWith("http") && /^https?:\/\/[^\/\s]/i.test(e) ? a.has(e) ? a.get(e) : (0, i.default)(_objectSpread({
                      path: (0, s.addQueryArgs)(r, n)
                    }, t)).then(function (t) {
                      return a.set(e, t), t;
                    }) : Promise.reject("".concat(e, " does not have a valid protocol. URLs must be \"http\" based")));

                  case 6:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12);
          }));

          return function _default(_x9) {
            return _ref15.apply(this, arguments);
          };
        }();

        t.default = _default;
      },
      942: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "__experimentalFetchLinkSuggestions", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        }), Object.defineProperty(t, "__experimentalFetchUrlData", {
          enumerable: !0,
          get: function get() {
            return s.default;
          }
        });
        var i = n(r(943)),
            s = n(r(46));
      },
      349: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = {
          store: !0,
          EntityProvider: !0
        };
        Object.defineProperty(t, "EntityProvider", {
          enumerable: !0,
          get: function get() {
            return v.default;
          }
        }), t.store = void 0;

        var s = r(467),
            a = n(r(463)),
            o = _interopRequireWildcard(r(13)),
            u = _interopRequireWildcard(r(708)),
            d = _interopRequireWildcard(r(345)),
            l = n(r(585)),
            c = r(85),
            p = r(971),
            v = _interopRequireWildcard(r(374));

        Object.keys(v).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(i, e) || e in t && t[e] === v[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function get() {
              return v[e];
            }
          }));
        });
        var y = r(942);

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              i = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var s in e) {
            if ("default" !== s && Object.prototype.hasOwnProperty.call(e, s)) {
              var a = i ? Object.getOwnPropertyDescriptor(e, s) : null;
              a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = e[s];
            }
          }

          return n.default = e, r && r.set(e, n), n;
        }

        Object.keys(y).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(i, e) || e in t && t[e] === y[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function get() {
              return y[e];
            }
          }));
        });
        var E = c.defaultEntities.reduce(function (e, t) {
          var r = t.kind,
              n = t.name;
          return e[(0, c.getMethodName)(r, n)] = function (e, t, i) {
            return o.getEntityRecord(e, r, n, t, i);
          }, e[(0, c.getMethodName)(r, n, "get", !0)] = function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) {
              i[s - 1] = arguments[s];
            }

            return o.getEntityRecords.apply(o, [e, r, n].concat(i));
          }, e;
        }, {}),
            m = c.defaultEntities.reduce(function (e, t) {
          var r = t.kind,
              n = t.name;

          e[(0, c.getMethodName)(r, n)] = function (e, t) {
            return d.getEntityRecord(r, n, e, t);
          };

          var i = (0, c.getMethodName)(r, n, "get", !0);
          return e[i] = function () {
            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
              t[i] = arguments[i];
            }

            return d.getEntityRecords.apply(d, [r, n].concat(t));
          }, e[i].shouldInvalidate = function (e) {
            var _d$getEntityRecords;

            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) {
              i[s - 1] = arguments[s];
            }

            return (_d$getEntityRecords = d.getEntityRecords).shouldInvalidate.apply(_d$getEntityRecords, [e, r, n].concat(i));
          }, e;
        }, {}),
            g = c.defaultEntities.reduce(function (e, t) {
          var r = t.kind,
              n = t.name;
          return e[(0, c.getMethodName)(r, n, "save")] = function (e) {
            return u.saveEntityRecord(r, n, e);
          }, e[(0, c.getMethodName)(r, n, "delete")] = function (e, t) {
            return u.deleteEntityRecord(r, n, e, t);
          }, e;
        }, {}),
            h = (0, s.createReduxStore)(p.STORE_NAME, {
          reducer: a.default,
          actions: _objectSpread(_objectSpread(_objectSpread({}, u), g), (0, l.default)()),
          selectors: _objectSpread(_objectSpread({}, o), E),
          resolvers: _objectSpread(_objectSpread({}, d), m),
          __experimentalUseThunks: !0
        });
        t.store = h, (0, s.register)(h);
      },
      585: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function createLocksActions() {
          var e = (0, i.default)();
          return {
            __unstableAcquireStoreLock: function __unstableAcquireStoreLock(t, r, n) {
              var i = n.exclusive;
              return function () {
                return e.acquire(t, r, i);
              };
            },
            __unstableReleaseStoreLock: function __unstableReleaseStoreLock(t) {
              return function () {
                return e.release(t);
              };
            }
          };
        };
        var i = n(r(447));
      },
      447: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function createLocks() {
          var e = (0, i.default)(void 0, {
            type: "@@INIT"
          });

          function processPendingLockRequests() {
            var _iterator4 = _createForOfIteratorHelper((0, s.getPendingLockRequests)(e)),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _t2 = _step4.value;
                var _r5 = _t2.store,
                    _n7 = _t2.path,
                    a = _t2.exclusive,
                    o = _t2.notifyAcquired;

                if ((0, s.isLockAvailable)(e, _r5, _n7, {
                  exclusive: a
                })) {
                  var _s4 = {
                    store: _r5,
                    path: _n7,
                    exclusive: a
                  };
                  e = (0, i.default)(e, {
                    type: "GRANT_LOCK_REQUEST",
                    lock: _s4,
                    request: _t2
                  }), o(_s4);
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }

          return {
            acquire: function acquire(t, r, n) {
              return new Promise(function (s) {
                e = (0, i.default)(e, {
                  type: "ENQUEUE_LOCK_REQUEST",
                  request: {
                    store: t,
                    path: r,
                    exclusive: n,
                    notifyAcquired: s
                  }
                }), processPendingLockRequests();
              });
            },
            release: function release(t) {
              e = (0, i.default)(e, {
                type: "RELEASE_LOCK",
                lock: t
              }), processPendingLockRequests();
            }
          };
        };
        var i = n(r(537)),
            s = r(141);
      },
      537: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function locks() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i,
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "ENQUEUE_LOCK_REQUEST":
              {
                var _r6 = t.request;
                return _objectSpread(_objectSpread({}, e), {}, {
                  requests: [_r6].concat(_toConsumableArray(e.requests))
                });
              }

            case "GRANT_LOCK_REQUEST":
              {
                var _r7 = t.lock,
                    _i5 = t.request,
                    s = _i5.store,
                    a = _i5.path,
                    o = [s].concat(_toConsumableArray(a)),
                    u = (0, n.deepCopyLocksTreePath)(e.tree, o),
                    d = (0, n.getNode)(u, o);
                return d.locks = [].concat(_toConsumableArray(d.locks), [_r7]), _objectSpread(_objectSpread({}, e), {}, {
                  requests: e.requests.filter(function (e) {
                    return e !== _i5;
                  }),
                  tree: u
                });
              }

            case "RELEASE_LOCK":
              {
                var _r8 = t.lock,
                    _i6 = [_r8.store].concat(_toConsumableArray(_r8.path)),
                    _s5 = (0, n.deepCopyLocksTreePath)(e.tree, _i6),
                    _a2 = (0, n.getNode)(_s5, _i6);

                return _a2.locks = _a2.locks.filter(function (e) {
                  return e !== _r8;
                }), _objectSpread(_objectSpread({}, e), {}, {
                  tree: _s5
                });
              }
          }

          return e;
        };
        var n = r(717);
        var i = {
          requests: [],
          tree: {
            locks: [],
            children: {}
          }
        };
      },
      141: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getPendingLockRequests = function getPendingLockRequests(e) {
          return e.requests;
        }, t.isLockAvailable = function isLockAvailable(e, t, r, i) {
          var s = i.exclusive;
          var a = [t].concat(_toConsumableArray(r)),
              o = e.tree;

          var _iterator5 = _createForOfIteratorHelper((0, n.iteratePath)(o, a)),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e5 = _step5.value;
              if ((0, n.hasConflictingLock)({
                exclusive: s
              }, _e5.locks)) return !1;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          var u = (0, n.getNode)(o, a);
          if (!u) return !0;

          var _iterator6 = _createForOfIteratorHelper((0, n.iterateDescendants)(u)),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _e6 = _step6.value;
              if ((0, n.hasConflictingLock)({
                exclusive: s
              }, _e6.locks)) return !1;
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          return !0;
        };
        var n = r(717);
      },
      717: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.deepCopyLocksTreePath = function deepCopyLocksTreePath(e, t) {
          var r = _objectSpread({}, e);

          var n = r;

          var _iterator7 = _createForOfIteratorHelper(t),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _e7 = _step7.value;
              n.children = _objectSpread(_objectSpread({}, n.children), {}, _defineProperty({}, _e7, _objectSpread({
                locks: [],
                children: {}
              }, n.children[_e7]))), n = n.children[_e7];
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          return r;
        }, t.getNode = function getNode(e, t) {
          var r = e;

          var _iterator8 = _createForOfIteratorHelper(t),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _e8 = _step8.value;
              var _t3 = r.children[_e8];
              if (!_t3) return null;
              r = _t3;
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          return r;
        }, t.hasConflictingLock = function hasConflictingLock(e, t) {
          var r = e.exclusive;
          if (r && t.length) return !0;
          if (!r && t.filter(function (e) {
            return e.exclusive;
          }).length) return !0;
          return !1;
        }, t.iterateDescendants = /*#__PURE__*/_regeneratorRuntime.mark(function iterateDescendants(e) {
          var t, _e9;

          return _regeneratorRuntime.wrap(function iterateDescendants$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  t = Object.values(e.children);

                case 1:
                  if (!t.length) {
                    _context13.next = 8;
                    break;
                  }

                  _e9 = t.pop();
                  _context13.next = 5;
                  return _e9;

                case 5:
                  t.push.apply(t, _toConsumableArray(Object.values(_e9.children)));

                case 6:
                  _context13.next = 1;
                  break;

                case 8:
                case "end":
                  return _context13.stop();
              }
            }
          }, iterateDescendants);
        }), t.iteratePath = /*#__PURE__*/_regeneratorRuntime.mark(function iteratePath(e, t) {
          var r, _iterator9, _step9, _e10, _t4;

          return _regeneratorRuntime.wrap(function iteratePath$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  r = e;
                  _context14.next = 3;
                  return r;

                case 3:
                  _iterator9 = _createForOfIteratorHelper(t);
                  _context14.prev = 4;

                  _iterator9.s();

                case 6:
                  if ((_step9 = _iterator9.n()).done) {
                    _context14.next = 16;
                    break;
                  }

                  _e10 = _step9.value;
                  _t4 = r.children[_e10];

                  if (_t4) {
                    _context14.next = 11;
                    break;
                  }

                  return _context14.abrupt("break", 16);

                case 11:
                  _context14.next = 13;
                  return _t4;

                case 13:
                  r = _t4;

                case 14:
                  _context14.next = 6;
                  break;

                case 16:
                  _context14.next = 21;
                  break;

                case 18:
                  _context14.prev = 18;
                  _context14.t0 = _context14["catch"](4);

                  _iterator9.e(_context14.t0);

                case 21:
                  _context14.prev = 21;

                  _iterator9.f();

                  return _context14.finish(21);

                case 24:
                case "end":
                  return _context14.stop();
              }
            }
          }, iteratePath, null, [[4, 18, 21, 24]]);
        });
      },
      971: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.STORE_NAME = void 0;
        t.STORE_NAME = "core";
      },
      327: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.receiveItems = receiveItems, t.receiveQueriedItems = function receiveQueriedItems(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 ? arguments[2] : void 0;
          return _objectSpread(_objectSpread({}, receiveItems(e, r)), {}, {
            query: t
          });
        }, t.removeItems = function removeItems(e, t, r) {
          var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          return {
            type: "REMOVE_ITEMS",
            itemIds: (0, n.castArray)(r),
            kind: e,
            name: t,
            invalidateCache: i
          };
        };
        var n = r(793);

        function receiveItems(e, t) {
          return {
            type: "RECEIVE_ITEMS",
            items: (0, n.castArray)(e),
            persistedEdits: t
          };
        }
      },
      332: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0, t.getQueryParts = getQueryParts;
        var n = r(904),
            i = r(785);

        function getQueryParts(e) {
          var t = {
            stableKey: "",
            page: 1,
            perPage: 10,
            fields: null,
            include: null,
            context: "default"
          },
              r = Object.keys(e).sort();

          for (var _s6 = 0; _s6 < r.length; _s6++) {
            var a = r[_s6];
            var o = e[a];

            switch (a) {
              case "page":
                t[a] = Number(o);
                break;

              case "per_page":
                t.perPage = Number(o);
                break;

              case "context":
                t.context = o;
                break;

              default:
                "_fields" === a && (t.fields = (0, i.getNormalizedCommaSeparable)(o), o = t.fields.join()), "include" === a && (t.include = (0, i.getNormalizedCommaSeparable)(o).map(Number), o = t.include.join()), t.stableKey += (t.stableKey ? "&" : "") + (0, n.addQueryArgs)("", _defineProperty({}, a, o)).slice(1);
            }
          }

          return t;
        }

        var s = (0, i.withWeakMapCache)(getQueryParts);
        t.default = s;
      },
      366: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = {
          reducer: !0
        };
        Object.defineProperty(t, "reducer", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        });
        var s = r(327);
        Object.keys(s).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(i, e) || e in t && t[e] === s[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function get() {
              return s[e];
            }
          }));
        });
        var a = r(167);
        Object.keys(a).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(i, e) || e in t && t[e] === a[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function get() {
              return a[e];
            }
          }));
        });
        var o = n(r(189));
      },
      189: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0, t.getMergedItemIds = getMergedItemIds, t.itemIsComplete = itemIsComplete, t.items = items;
        var i = r(793),
            s = r(467),
            a = r(785),
            o = r(85),
            u = n(r(332));

        function getContextFromAction(e) {
          var t = e.query;
          if (!t) return "default";
          return (0, u.default)(t).context;
        }

        function getMergedItemIds(e, t, r, n) {
          if (1 === r && -1 === n) return t;
          var i = (r - 1) * n,
              s = Math.max(e.length, i + t.length),
              a = new Array(s);

          for (var _r9 = 0; _r9 < s; _r9++) {
            var _n8 = _r9 >= i && _r9 < i + t.length;

            a[_r9] = _n8 ? t[_r9 - i] : e[_r9];
          }

          return a;
        }

        function items() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "RECEIVE_ITEMS":
              {
                var _r10 = getContextFromAction(t),
                    _n9 = t.key || o.DEFAULT_ENTITY_KEY;

                return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, _r10, _objectSpread(_objectSpread({}, e[_r10]), t.items.reduce(function (t, i) {
                  var s;
                  var o = i[_n9];
                  return t[o] = (0, a.conservativeMapItem)(null == e || null === (s = e[_r10]) || void 0 === s ? void 0 : s[o], i), t;
                }, {}))));
              }

            case "REMOVE_ITEMS":
              return (0, i.mapValues)(e, function (e) {
                return (0, i.omit)(e, t.itemIds);
              });
          }

          return e;
        }

        function itemIsComplete() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "RECEIVE_ITEMS":
              {
                var _r11 = getContextFromAction(t),
                    _n10 = t.query,
                    _t$key = t.key,
                    _i7 = _t$key === void 0 ? o.DEFAULT_ENTITY_KEY : _t$key,
                    _s7 = _n10 ? (0, u.default)(_n10) : {},
                    _a3 = !_n10 || !Array.isArray(_s7.fields);

                return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, _r11, _objectSpread(_objectSpread({}, e[_r11]), t.items.reduce(function (t, n) {
                  var s;
                  var o = n[_i7];
                  return t[o] = (null == e || null === (s = e[_r11]) || void 0 === s ? void 0 : s[o]) || _a3, t;
                }, {}))));
              }

            case "REMOVE_ITEMS":
              return (0, i.mapValues)(e, function (e) {
                return (0, i.omit)(e, t.itemIds);
              });
          }

          return e;
        }

        var d = (0, i.flowRight)([(0, a.ifMatchingAction)(function (e) {
          return "query" in e;
        }), (0, a.replaceAction)(function (e) {
          return e.query ? _objectSpread(_objectSpread({}, e), (0, u.default)(e.query)) : e;
        }), (0, a.onSubKey)("context"), (0, a.onSubKey)("stableKey")])(function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              t = arguments.length > 1 ? arguments[1] : void 0;
          var r = t.type,
              n = t.page,
              s = t.perPage,
              _t$key2 = t.key,
              a = _t$key2 === void 0 ? o.DEFAULT_ENTITY_KEY : _t$key2;
          return "RECEIVE_ITEMS" !== r ? e : getMergedItemIds(e || [], (0, i.map)(t.items, a), n, s);
        });
        var l = (0, s.combineReducers)({
          items: items,
          itemIsComplete: itemIsComplete,
          queries: function queries() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 ? arguments[1] : void 0;

            switch (t.type) {
              case "RECEIVE_ITEMS":
                return d(e, t);

              case "REMOVE_ITEMS":
                var _r12 = t.itemIds.reduce(function (e, t) {
                  return e[t] = !0, e;
                }, {});

                return (0, i.mapValues)(e, function (e) {
                  return (0, i.mapValues)(e, function (e) {
                    return (0, i.filter)(e, function (e) {
                      return !_r12[e];
                    });
                  });
                });

              default:
                return e;
            }
          }
        });
        t.default = l;
      },
      167: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getQueriedItems = void 0;
        var i = n(r(235)),
            s = n(r(820)),
            a = r(793),
            o = n(r(332));
        var u = new WeakMap();

        function getQueriedItemsUncached(e, t) {
          var r, n;

          var _ref17 = (0, o.default)(t),
              i = _ref17.stableKey,
              s = _ref17.page,
              u = _ref17.perPage,
              d = _ref17.include,
              l = _ref17.fields,
              c = _ref17.context;

          var p;
          if (null !== (r = e.queries) && void 0 !== r && null !== (n = r[c]) && void 0 !== n && n[i] && (p = e.queries[c][i]), !p) return null;
          var v = -1 === u ? 0 : (s - 1) * u,
              y = -1 === u ? p.length : Math.min(v + u, p.length),
              E = [];

          for (var _t5 = v; _t5 < y; _t5++) {
            var m;
            var _r13 = p[_t5];
            if (Array.isArray(d) && !d.includes(_r13)) continue;
            if (null === (m = e.items[c]) || void 0 === m || !m.hasOwnProperty(_r13)) return null;
            var _n11 = e.items[c][_r13];

            var _i8 = void 0;

            if (Array.isArray(l)) {
              _i8 = {};

              for (var _e11 = 0; _e11 < l.length; _e11++) {
                var _t6 = l[_e11].split("."),
                    _r14 = (0, a.get)(_n11, _t6);

                (0, a.set)(_i8, _t6, _r14);
              }
            } else {
              var g;
              if (null === (g = e.itemIsComplete[c]) || void 0 === g || !g[_r13]) return null;
              _i8 = _n11;
            }

            E.push(_i8);
          }

          return E;
        }

        var d = (0, i.default)(function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = u.get(e);

          if (r) {
            var _e12 = r.get(t);

            if (void 0 !== _e12) return _e12;
          } else r = new s.default(), u.set(e, r);

          var n = getQueriedItemsUncached(e, t);
          return r.set(t, n), n;
        });
        t.getQueriedItems = d;
      },
      463: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.autosaves = autosaves, t.currentGlobalStylesId = currentGlobalStylesId, t.currentTheme = currentTheme, t.currentUser = currentUser, t.default = void 0, t.embedPreviews = embedPreviews, t.entities = void 0, t.entitiesConfig = entitiesConfig, t.taxonomies = taxonomies, t.terms = terms, t.themeBaseGlobalStyles = themeBaseGlobalStyles, t.undo = undo, t.userPermissions = userPermissions, t.users = users;
        var i = r(793),
            s = r(467),
            a = n(r(626)),
            o = r(785),
            u = r(366),
            d = r(85);

        function terms() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_TERMS" === t.type ? _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.taxonomy, t.terms)) : e;
        }

        function users() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            byId: {},
            queries: {}
          },
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_USER_QUERY" === t.type ? {
            byId: _objectSpread(_objectSpread({}, e.byId), (0, i.keyBy)(t.users, "id")),
            queries: _objectSpread(_objectSpread({}, e.queries), {}, _defineProperty({}, t.queryID, (0, i.map)(t.users, function (e) {
              return e.id;
            })))
          } : e;
        }

        function currentUser() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_CURRENT_USER" === t.type ? t.currentUser : e;
        }

        function taxonomies() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_TAXONOMIES" === t.type ? t.taxonomies : e;
        }

        function currentTheme() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_CURRENT_THEME" === t.type ? t.currentTheme.stylesheet : e;
        }

        function currentGlobalStylesId() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_CURRENT_GLOBAL_STYLES_ID" === t.type ? t.id : e;
        }

        function themeBaseGlobalStyles() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_THEME_GLOBAL_STYLES" === t.type ? _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.stylesheet, t.globalStyles)) : e;
        }

        function entity(e) {
          return (0, i.flowRight)([(0, o.ifMatchingAction)(function (t) {
            return t.name && t.kind && t.name === e.name && t.kind === e.kind;
          }), (0, o.replaceAction)(function (t) {
            return _objectSpread(_objectSpread({}, t), {}, {
              key: e.key || d.DEFAULT_ENTITY_KEY
            });
          })])((0, s.combineReducers)({
            queriedData: u.reducer,
            edits: function edits() {
              var e, t;
              var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  n = arguments.length > 1 ? arguments[1] : void 0;

              switch (n.type) {
                case "RECEIVE_ITEMS":
                  if ("default" !== (null !== (e = null == n || null === (t = n.query) || void 0 === t ? void 0 : t.context) && void 0 !== e ? e : "default")) return r;

                  var _s8 = _objectSpread({}, r);

                  var _iterator10 = _createForOfIteratorHelper(n.items),
                      _step10;

                  try {
                    var _loop2 = function _loop2() {
                      var e = _step10.value;
                      var t = e[n.key],
                          r = _s8[t];
                      if (!r) return "continue";
                      var a = Object.keys(r).reduce(function (t, s) {
                        return (0, i.isEqual)(r[s], (0, i.get)(e[s], "raw", e[s])) || n.persistedEdits && (0, i.isEqual)(r[s], n.persistedEdits[s]) || (t[s] = r[s]), t;
                      }, {});
                      Object.keys(a).length ? _s8[t] = a : delete _s8[t];
                    };

                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                      var _ret = _loop2();

                      if (_ret === "continue") continue;
                    }
                  } catch (err) {
                    _iterator10.e(err);
                  } finally {
                    _iterator10.f();
                  }

                  return _s8;

                case "EDIT_ENTITY_RECORD":
                  var _a4 = _objectSpread(_objectSpread({}, r[n.recordId]), n.edits);

                  return Object.keys(_a4).forEach(function (e) {
                    void 0 === _a4[e] && delete _a4[e];
                  }), _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, n.recordId, _a4));
              }

              return r;
            },
            saving: function saving() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = arguments.length > 1 ? arguments[1] : void 0;

              switch (t.type) {
                case "SAVE_ENTITY_RECORD_START":
                case "SAVE_ENTITY_RECORD_FINISH":
                  return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.recordId, {
                    pending: "SAVE_ENTITY_RECORD_START" === t.type,
                    error: t.error,
                    isAutosave: t.isAutosave
                  }));
              }

              return e;
            },
            deleting: function deleting() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = arguments.length > 1 ? arguments[1] : void 0;

              switch (t.type) {
                case "DELETE_ENTITY_RECORD_START":
                case "DELETE_ENTITY_RECORD_FINISH":
                  return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.recordId, {
                    pending: "DELETE_ENTITY_RECORD_START" === t.type,
                    error: t.error
                  }));
              }

              return e;
            }
          }));
        }

        function entitiesConfig() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : d.defaultEntities,
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "ADD_ENTITIES" === t.type ? [].concat(_toConsumableArray(e), _toConsumableArray(t.entities)) : e;
        }

        var entities = function entities() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          var r = entitiesConfig(e.config, t);
          var n = e.reducer;

          if (!n || r !== e.config) {
            var _e13 = (0, i.groupBy)(r, "kind");

            n = (0, s.combineReducers)(Object.entries(_e13).reduce(function (e, t) {
              var _t7 = _slicedToArray(t, 2),
                  r = _t7[0],
                  n = _t7[1];

              var i = (0, s.combineReducers)(n.reduce(function (e, t) {
                return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.name, entity(t)));
              }, {}));
              return e[r] = i, e;
            }, {}));
          }

          var a = n(e.data, t);
          return a === e.data && r === e.config && n === e.reducer ? e : {
            reducer: n,
            data: a,
            config: r
          };
        };

        t.entities = entities;
        var l = [];
        var c;

        function undo() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l,
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "EDIT_ENTITY_RECORD":
            case "CREATE_UNDO_LEVEL":
              var _r15 = "CREATE_UNDO_LEVEL" === t.type;

              var _n12 = !_r15 && (t.meta.isUndo || t.meta.isRedo);

              var _i9;

              if (_r15 ? t = c : _n12 || (c = Object.keys(t.edits).some(function (e) {
                return !t.transientEdits[e];
              }) ? t : _objectSpread(_objectSpread({}, t), {}, {
                edits: _objectSpread(_objectSpread({}, c && c.edits), t.edits)
              })), _n12) {
                if (_i9 = _toConsumableArray(e), _i9.offset = e.offset + (t.meta.isUndo ? -1 : 1), !e.flattenedUndo) return _i9;
                _r15 = !0, t = c;
              }

              if (!t.meta.undo) return e;
              if (!_r15 && !Object.keys(t.edits).some(function (e) {
                return !t.transientEdits[e];
              })) return _i9 = _toConsumableArray(e), _i9.flattenedUndo = _objectSpread(_objectSpread({}, e.flattenedUndo), t.edits), _i9.offset = e.offset, _i9;
              _i9 = _i9 || e.slice(0, e.offset || void 0), _i9.offset = _i9.offset || 0, _i9.pop(), _r15 || _i9.push({
                kind: t.meta.undo.kind,
                name: t.meta.undo.name,
                recordId: t.meta.undo.recordId,
                edits: _objectSpread(_objectSpread({}, e.flattenedUndo), t.meta.undo.edits)
              });

              var _s9 = Object.values(t.meta.undo.edits).filter(function (e) {
                return "function" != typeof e;
              }),
                  _o = Object.values(t.edits).filter(function (e) {
                return "function" != typeof e;
              });

              return (0, a.default)(_s9, _o) || _i9.push({
                kind: t.kind,
                name: t.name,
                recordId: t.recordId,
                edits: _r15 ? _objectSpread(_objectSpread({}, e.flattenedUndo), t.edits) : t.edits
              }), _i9;
          }

          return e;
        }

        function embedPreviews() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          if ("RECEIVE_EMBED_PREVIEW" === t.type) {
            var _r16 = t.url,
                _n13 = t.preview;
            return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, _r16, _n13));
          }

          return e;
        }

        function userPermissions() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;
          return "RECEIVE_USER_PERMISSION" === t.type ? _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.key, t.isAllowed)) : e;
        }

        function autosaves() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          if ("RECEIVE_AUTOSAVES" === t.type) {
            var _r17 = t.postId,
                _n14 = t.autosaves;
            return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, _r17, _n14));
          }

          return e;
        }

        l.offset = 0;
        var p = (0, s.combineReducers)({
          terms: terms,
          users: users,
          currentTheme: currentTheme,
          currentGlobalStylesId: currentGlobalStylesId,
          currentUser: currentUser,
          themeBaseGlobalStyles: themeBaseGlobalStyles,
          taxonomies: taxonomies,
          entities: entities,
          undo: undo,
          embedPreviews: embedPreviews,
          userPermissions: userPermissions,
          autosaves: autosaves
        });
        t.default = p;
      },
      345: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getThemeSupports = t.getRawEntityRecord = t.getEntityRecords = t.getEntityRecord = t.getEmbedPreview = t.getEditedEntityRecord = t.getCurrentUser = t.getCurrentTheme = t.getAutosaves = t.getAutosave = t.getAuthors = t.canUserEditEntityRecord = t.canUser = t.__experimentalGetTemplateForLink = t.__experimentalGetCurrentThemeBaseGlobalStyles = t.__experimentalGetCurrentGlobalStylesId = void 0;
        var i = r(793),
            s = r(904),
            a = n(r(507)),
            o = r(971),
            u = r(85),
            d = r(785);

        t.getAuthors = function (e) {
          return /*#__PURE__*/function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t) {
              var r, n, i;
              return _regeneratorRuntime.wrap(function _callee13$(_context15) {
                while (1) {
                  switch (_context15.prev = _context15.next) {
                    case 0:
                      r = t.dispatch;
                      n = (0, s.addQueryArgs)("/wp/v2/users/?who=authors&per_page=100", e);
                      _context15.next = 4;
                      return (0, a.default)({
                        path: n
                      });

                    case 4:
                      i = _context15.sent;
                      r.receiveUserQuery(n, i);

                    case 6:
                    case "end":
                      return _context15.stop();
                  }
                }
              }, _callee13);
            }));

            return function (_x10) {
              return _ref18.apply(this, arguments);
            };
          }();
        };

        t.getCurrentUser = function () {
          return /*#__PURE__*/function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
              var t, r;
              return _regeneratorRuntime.wrap(function _callee14$(_context16) {
                while (1) {
                  switch (_context16.prev = _context16.next) {
                    case 0:
                      t = e.dispatch;
                      _context16.next = 3;
                      return (0, a.default)({
                        path: "/wp/v2/users/me"
                      });

                    case 3:
                      r = _context16.sent;
                      t.receiveCurrentUser(r);

                    case 5:
                    case "end":
                      return _context16.stop();
                  }
                }
              }, _callee14);
            }));

            return function (_x11) {
              return _ref19.apply(this, arguments);
            };
          }();
        };

        t.getEntityRecord = function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              n = arguments.length > 3 ? arguments[3] : void 0;
          return /*#__PURE__*/function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(l) {
              var c, p, v, y, E, _o2, _l2;

              return _regeneratorRuntime.wrap(function _callee15$(_context17) {
                while (1) {
                  switch (_context17.prev = _context17.next) {
                    case 0:
                      c = l.select, p = l.dispatch;
                      _context17.next = 3;
                      return p((0, u.getKindEntities)(e));

                    case 3:
                      v = _context17.sent;
                      y = (0, i.find)(v, {
                        kind: e,
                        name: t
                      });

                      if (!(!y || null != y && y.__experimentalNoFetch)) {
                        _context17.next = 7;
                        break;
                      }

                      return _context17.abrupt("return");

                    case 7:
                      _context17.next = 9;
                      return p.__unstableAcquireStoreLock(o.STORE_NAME, ["entities", "data", e, t, r], {
                        exclusive: !1
                      });

                    case 9:
                      E = _context17.sent;
                      _context17.prev = 10;
                      void 0 !== n && n._fields && (n = _objectSpread(_objectSpread({}, n), {}, {
                        _fields: (0, i.uniq)([].concat(_toConsumableArray((0, d.getNormalizedCommaSeparable)(n._fields) || []), [y.key || u.DEFAULT_ENTITY_KEY])).join()
                      }));
                      _o2 = (0, s.addQueryArgs)(y.baseURL + (r ? "/" + r : ""), _objectSpread(_objectSpread({}, y.baseURLParams), n));

                      if (!(void 0 !== n)) {
                        _context17.next = 17;
                        break;
                      }

                      n = _objectSpread(_objectSpread({}, n), {}, {
                        include: [r]
                      });

                      if (!c.hasEntityRecords(e, t, n)) {
                        _context17.next = 17;
                        break;
                      }

                      return _context17.abrupt("return");

                    case 17:
                      _context17.next = 19;
                      return (0, a.default)({
                        path: _o2
                      });

                    case 19:
                      _l2 = _context17.sent;
                      p.receiveEntityRecords(e, t, _l2, n);
                      _context17.next = 25;
                      break;

                    case 23:
                      _context17.prev = 23;
                      _context17.t0 = _context17["catch"](10);

                    case 25:
                      _context17.prev = 25;

                      p.__unstableReleaseStoreLock(E);

                      return _context17.finish(25);

                    case 28:
                    case "end":
                      return _context17.stop();
                  }
                }
              }, _callee15, null, [[10, 23, 25, 28]]);
            }));

            return function (_x12) {
              return _ref20.apply(this, arguments);
            };
          }();
        };

        var l = (0, d.forwardResolver)("getEntityRecord");
        t.getRawEntityRecord = l;
        var c = (0, d.forwardResolver)("getEntityRecord");
        t.getEditedEntityRecord = c;

        var getEntityRecords = function getEntityRecords(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return /*#__PURE__*/function () {
            var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(n) {
              var l, c, p, v, y, _n15, _o3, _r18, _n16;

              return _regeneratorRuntime.wrap(function _callee16$(_context18) {
                while (1) {
                  switch (_context18.prev = _context18.next) {
                    case 0:
                      l = n.dispatch;
                      _context18.next = 3;
                      return l((0, u.getKindEntities)(e));

                    case 3:
                      c = _context18.sent;
                      p = (0, i.find)(c, {
                        kind: e,
                        name: t
                      });

                      if (!(!p || null != p && p.__experimentalNoFetch)) {
                        _context18.next = 7;
                        break;
                      }

                      return _context18.abrupt("return");

                    case 7:
                      _context18.next = 9;
                      return l.__unstableAcquireStoreLock(o.STORE_NAME, ["entities", "data", e, t], {
                        exclusive: !1
                      });

                    case 9:
                      v = _context18.sent;
                      _context18.prev = 10;
                      r._fields && (r = _objectSpread(_objectSpread({}, r), {}, {
                        _fields: (0, i.uniq)([].concat(_toConsumableArray((0, d.getNormalizedCommaSeparable)(r._fields) || []), [p.key || u.DEFAULT_ENTITY_KEY])).join()
                      }));
                      _n15 = (0, s.addQueryArgs)(p.baseURL, _objectSpread(_objectSpread({}, p.baseURLParams), r));
                      _context18.t0 = Object;
                      _context18.next = 16;
                      return (0, a.default)({
                        path: _n15
                      });

                    case 16:
                      _context18.t1 = _context18.sent;
                      _o3 = _context18.t0.values.call(_context18.t0, _context18.t1);

                      if (r._fields && (_o3 = _o3.map(function (e) {
                        return r._fields.split(",").forEach(function (t) {
                          e.hasOwnProperty(t) || (e[t] = void 0);
                        }), e;
                      })), l.receiveEntityRecords(e, t, _o3, r), !(null !== (y = r) && void 0 !== y && y._fields || r.context)) {
                        _r18 = p.key || u.DEFAULT_ENTITY_KEY, _n16 = _o3.filter(function (e) {
                          return e[_r18];
                        }).map(function (n) {
                          return [e, t, n[_r18]];
                        });
                        l({
                          type: "START_RESOLUTIONS",
                          selectorName: "getEntityRecord",
                          args: _n16
                        }), l({
                          type: "FINISH_RESOLUTIONS",
                          selectorName: "getEntityRecord",
                          args: _n16
                        });
                      }

                      _context18.next = 23;
                      break;

                    case 21:
                      _context18.prev = 21;
                      _context18.t2 = _context18["catch"](10);

                    case 23:
                      _context18.prev = 23;

                      l.__unstableReleaseStoreLock(v);

                      return _context18.finish(23);

                    case 26:
                    case "end":
                      return _context18.stop();
                  }
                }
              }, _callee16, null, [[10, 21, 23, 26]]);
            }));

            return function (_x13) {
              return _ref21.apply(this, arguments);
            };
          }();
        };

        t.getEntityRecords = getEntityRecords, getEntityRecords.shouldInvalidate = function (e, t, r) {
          return ("RECEIVE_ITEMS" === e.type || "REMOVE_ITEMS" === e.type) && e.invalidateCache && t === e.kind && r === e.name;
        };

        t.getCurrentTheme = function () {
          return /*#__PURE__*/function () {
            var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(e) {
              var t, r, n;
              return _regeneratorRuntime.wrap(function _callee17$(_context19) {
                while (1) {
                  switch (_context19.prev = _context19.next) {
                    case 0:
                      t = e.dispatch, r = e.resolveSelect;
                      _context19.next = 3;
                      return r.getEntityRecords("root", "theme", {
                        status: "active"
                      });

                    case 3:
                      n = _context19.sent;
                      t.receiveCurrentTheme(n[0]);

                    case 5:
                    case "end":
                      return _context19.stop();
                  }
                }
              }, _callee17);
            }));

            return function (_x14) {
              return _ref22.apply(this, arguments);
            };
          }();
        };

        var p = (0, d.forwardResolver)("getCurrentTheme");
        t.getThemeSupports = p;

        t.getEmbedPreview = function (e) {
          return /*#__PURE__*/function () {
            var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t) {
              var r, _t8;

              return _regeneratorRuntime.wrap(function _callee18$(_context20) {
                while (1) {
                  switch (_context20.prev = _context20.next) {
                    case 0:
                      r = t.dispatch;
                      _context20.prev = 1;
                      _context20.next = 4;
                      return (0, a.default)({
                        path: (0, s.addQueryArgs)("/oembed/1.0/proxy", {
                          url: e
                        })
                      });

                    case 4:
                      _t8 = _context20.sent;
                      r.receiveEmbedPreview(e, _t8);
                      _context20.next = 11;
                      break;

                    case 8:
                      _context20.prev = 8;
                      _context20.t0 = _context20["catch"](1);
                      r.receiveEmbedPreview(e, !1);

                    case 11:
                    case "end":
                      return _context20.stop();
                  }
                }
              }, _callee18, null, [[1, 8]]);
            }));

            return function (_x15) {
              return _ref23.apply(this, arguments);
            };
          }();
        };

        var canUser = function canUser(e, t, r) {
          return /*#__PURE__*/function () {
            var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(n) {
              var s, o, u, d, l, c, p;
              return _regeneratorRuntime.wrap(function _callee19$(_context21) {
                while (1) {
                  switch (_context21.prev = _context21.next) {
                    case 0:
                      s = n.dispatch;
                      o = {
                        create: "POST",
                        read: "GET",
                        update: "PUT",
                        delete: "DELETE"
                      }[e];

                      if (o) {
                        _context21.next = 4;
                        break;
                      }

                      throw new Error("'".concat(e, "' is not a valid action."));

                    case 4:
                      u = r ? "/wp/v2/".concat(t, "/").concat(r) : "/wp/v2/".concat(t);
                      _context21.prev = 5;
                      _context21.next = 8;
                      return (0, a.default)({
                        path: u,
                        method: r ? "GET" : "OPTIONS",
                        parse: !1
                      });

                    case 8:
                      d = _context21.sent;
                      _context21.next = 14;
                      break;

                    case 11:
                      _context21.prev = 11;
                      _context21.t0 = _context21["catch"](5);
                      return _context21.abrupt("return");

                    case 14:
                      l = (0, i.hasIn)(d, ["headers", "get"]) ? d.headers.get("allow") : (0, i.get)(d, ["headers", "Allow"], "");
                      c = (0, i.compact)([e, t, r]).join("/"), p = (0, i.includes)(l, o);
                      s.receiveUserPermission(c, p);

                    case 17:
                    case "end":
                      return _context21.stop();
                  }
                }
              }, _callee19, null, [[5, 11]]);
            }));

            return function (_x16) {
              return _ref24.apply(this, arguments);
            };
          }();
        };

        t.canUser = canUser;

        t.canUserEditEntityRecord = function (e, t, r) {
          return /*#__PURE__*/function () {
            var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(n) {
              var s, a, o, d;
              return _regeneratorRuntime.wrap(function _callee20$(_context22) {
                while (1) {
                  switch (_context22.prev = _context22.next) {
                    case 0:
                      s = n.dispatch;
                      _context22.next = 3;
                      return s((0, u.getKindEntities)(e));

                    case 3:
                      a = _context22.sent;
                      o = (0, i.find)(a, {
                        kind: e,
                        name: t
                      });

                      if (o) {
                        _context22.next = 7;
                        break;
                      }

                      return _context22.abrupt("return");

                    case 7:
                      d = o.__unstable_rest_base;
                      _context22.next = 10;
                      return s(canUser("update", d, r));

                    case 10:
                    case "end":
                      return _context22.stop();
                  }
                }
              }, _callee20);
            }));

            return function (_x17) {
              return _ref25.apply(this, arguments);
            };
          }();
        };

        t.getAutosaves = function (e, t) {
          return /*#__PURE__*/function () {
            var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(r) {
              var n, i, _yield$i$getPostType, s, o;

              return _regeneratorRuntime.wrap(function _callee21$(_context23) {
                while (1) {
                  switch (_context23.prev = _context23.next) {
                    case 0:
                      n = r.dispatch, i = r.resolveSelect;
                      _context23.next = 3;
                      return i.getPostType(e);

                    case 3:
                      _yield$i$getPostType = _context23.sent;
                      s = _yield$i$getPostType.rest_base;
                      _context23.next = 7;
                      return (0, a.default)({
                        path: "/wp/v2/".concat(s, "/").concat(t, "/autosaves?context=edit")
                      });

                    case 7:
                      o = _context23.sent;
                      o && o.length && n.receiveAutosaves(t, o);

                    case 9:
                    case "end":
                      return _context23.stop();
                  }
                }
              }, _callee21);
            }));

            return function (_x18) {
              return _ref26.apply(this, arguments);
            };
          }();
        };

        t.getAutosave = function (e, t) {
          return /*#__PURE__*/function () {
            var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(r) {
              var n;
              return _regeneratorRuntime.wrap(function _callee22$(_context24) {
                while (1) {
                  switch (_context24.prev = _context24.next) {
                    case 0:
                      n = r.resolveSelect;
                      _context24.next = 3;
                      return n.getAutosaves(e, t);

                    case 3:
                    case "end":
                      return _context24.stop();
                  }
                }
              }, _callee22);
            }));

            return function (_x19) {
              return _ref27.apply(this, arguments);
            };
          }();
        };

        var __experimentalGetTemplateForLink = function __experimentalGetTemplateForLink(e) {
          return /*#__PURE__*/function () {
            var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t) {
              var r, n, i, a;
              return _regeneratorRuntime.wrap(function _callee23$(_context25) {
                while (1) {
                  switch (_context25.prev = _context25.next) {
                    case 0:
                      n = t.dispatch, i = t.resolveSelect;
                      _context25.prev = 1;
                      _context25.next = 4;
                      return window.fetch((0, s.addQueryArgs)(e, {
                        "_wp-find-template": !0
                      })).then(function (e) {
                        return e.json();
                      }).then(function (e) {
                        var t = e.data;
                        return t;
                      });

                    case 4:
                      r = _context25.sent;
                      _context25.next = 9;
                      break;

                    case 7:
                      _context25.prev = 7;
                      _context25.t0 = _context25["catch"](1);

                    case 9:
                      if (r) {
                        _context25.next = 11;
                        break;
                      }

                      return _context25.abrupt("return");

                    case 11:
                      _context25.next = 13;
                      return i.getEntityRecord("postType", "wp_template", r.id);

                    case 13:
                      a = _context25.sent;
                      a && n.receiveEntityRecords("postType", "wp_template", [a], {
                        "find-template": e
                      });

                    case 15:
                    case "end":
                      return _context25.stop();
                  }
                }
              }, _callee23, null, [[1, 7]]);
            }));

            return function (_x20) {
              return _ref28.apply(this, arguments);
            };
          }();
        };

        t.__experimentalGetTemplateForLink = __experimentalGetTemplateForLink, __experimentalGetTemplateForLink.shouldInvalidate = function (e) {
          return ("RECEIVE_ITEMS" === e.type || "REMOVE_ITEMS" === e.type) && e.invalidateCache && "postType" === e.kind && "wp_template" === e.name;
        };

        t.__experimentalGetCurrentGlobalStylesId = function () {
          return /*#__PURE__*/function () {
            var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(e) {
              var t, r, n, s, _e14;

              return _regeneratorRuntime.wrap(function _callee24$(_context26) {
                while (1) {
                  switch (_context26.prev = _context26.next) {
                    case 0:
                      t = e.dispatch, r = e.resolveSelect;
                      _context26.next = 3;
                      return r.getEntityRecords("root", "theme", {
                        status: "active"
                      });

                    case 3:
                      n = _context26.sent;
                      s = (0, i.get)(n, [0, "_links", "wp:user-global-styles", 0, "href"]);

                      if (!s) {
                        _context26.next = 10;
                        break;
                      }

                      _context26.next = 8;
                      return (0, a.default)({
                        url: s
                      });

                    case 8:
                      _e14 = _context26.sent;

                      t.__experimentalReceiveCurrentGlobalStylesId(_e14.id);

                    case 10:
                    case "end":
                      return _context26.stop();
                  }
                }
              }, _callee24);
            }));

            return function (_x21) {
              return _ref29.apply(this, arguments);
            };
          }();
        };

        t.__experimentalGetCurrentThemeBaseGlobalStyles = function () {
          return /*#__PURE__*/function () {
            var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e) {
              var t, r, n, i;
              return _regeneratorRuntime.wrap(function _callee25$(_context27) {
                while (1) {
                  switch (_context27.prev = _context27.next) {
                    case 0:
                      t = e.resolveSelect, r = e.dispatch;
                      _context27.next = 3;
                      return t.getCurrentTheme();

                    case 3:
                      n = _context27.sent;
                      _context27.next = 6;
                      return (0, a.default)({
                        path: "/wp/v2/global-styles/themes/".concat(n.stylesheet)
                      });

                    case 6:
                      i = _context27.sent;
                      _context27.next = 9;
                      return r.__experimentalReceiveThemeBaseGlobalStyles(n.stylesheet, i);

                    case 9:
                    case "end":
                      return _context27.stop();
                  }
                }
              }, _callee25);
            }));

            return function (_x22) {
              return _ref30.apply(this, arguments);
            };
          }();
        };
      },
      13: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.__experimentalGetCurrentGlobalStylesId = function __experimentalGetCurrentGlobalStylesId(e) {
          return e.currentGlobalStylesId;
        }, t.__experimentalGetCurrentThemeBaseGlobalStyles = function __experimentalGetCurrentThemeBaseGlobalStyles(e) {
          var t = getCurrentTheme(e);
          if (!t) return null;
          return e.themeBaseGlobalStyles[t.stylesheet];
        }, t.__experimentalGetEntitiesBeingSaved = t.__experimentalGetDirtyEntityRecords = void 0, t.__experimentalGetEntityRecordNoResolver = function __experimentalGetEntityRecordNoResolver(e, t, r, n) {
          return g(e, t, r, n);
        }, t.__experimentalGetTemplateForLink = function __experimentalGetTemplateForLink(e, t) {
          var r = getEntityRecords(e, "postType", "wp_template", {
            "find-template": t
          }),
              n = null != r && r.length ? r[0] : null;
          if (n) return T(e, "postType", "wp_template", n.id);
          return n;
        }, t.canUser = canUser, t.canUserEditEntityRecord = function canUserEditEntityRecord(e, t, r, n) {
          var i = getEntity(e, t, r);
          if (!i) return !1;
          var s = i.__unstable_rest_base;
          return canUser(e, "update", s, n);
        }, t.getAuthors = function getAuthors(e, t) {
          (0, u.default)("select( 'core' ).getAuthors()", {
            since: "5.9",
            alternative: "select( 'core' ).getUsers({ who: 'authors' })"
          });
          var r = (0, o.addQueryArgs)("/wp/v2/users/?who=authors&per_page=100", t);
          return m(e, r);
        }, t.getAutosave = function getAutosave(e, t, r, n) {
          if (void 0 === n) return;
          var i = e.autosaves[r];
          return (0, s.find)(i, {
            author: n
          });
        }, t.getAutosaves = function getAutosaves(e, t, r) {
          return e.autosaves[r];
        }, t.getCurrentTheme = getCurrentTheme, t.getCurrentUser = function getCurrentUser(e) {
          return e.currentUser;
        }, t.getEditedEntityRecord = void 0, t.getEmbedPreview = function getEmbedPreview(e, t) {
          return e.embedPreviews[t];
        }, t.getEntitiesByKind = function getEntitiesByKind(e, t) {
          return (0, s.filter)(e.entities.config, {
            kind: t
          });
        }, t.getEntity = getEntity, t.getEntityRecord = void 0, t.getEntityRecordEdits = getEntityRecordEdits, t.getEntityRecordNonTransientEdits = void 0, t.getEntityRecords = getEntityRecords, t.getLastEntityDeleteError = function getLastEntityDeleteError(e, t, r, n) {
          return (0, s.get)(e.entities.data, [t, r, "deleting", n, "error"]);
        }, t.getLastEntitySaveError = function getLastEntitySaveError(e, t, r, n) {
          return (0, s.get)(e.entities.data, [t, r, "saving", n, "error"]);
        }, t.getRawEntityRecord = void 0, t.getRedoEdit = getRedoEdit, t.getReferenceByDistinctEdits = void 0, t.getThemeSupports = function getThemeSupports(e) {
          var t, r;
          return null !== (t = null === (r = getCurrentTheme(e)) || void 0 === r ? void 0 : r.theme_supports) && void 0 !== t ? t : v;
        }, t.getUndoEdit = getUndoEdit, t.getUserQueryResults = void 0, t.hasEditsForEntityRecord = hasEditsForEntityRecord, t.hasEntityRecords = function hasEntityRecords(e, t, r, n) {
          return Array.isArray(getEntityRecords(e, t, r, n));
        }, t.hasFetchedAutosaves = void 0, t.hasRedo = function hasRedo(e) {
          return Boolean(getRedoEdit(e));
        }, t.hasUndo = function hasUndo(e) {
          return Boolean(getUndoEdit(e));
        }, t.isAutosavingEntityRecord = function isAutosavingEntityRecord(e, t, r, n) {
          var _ref31 = (0, s.get)(e.entities.data, [t, r, "saving", n], {}),
              i = _ref31.pending,
              a = _ref31.isAutosave;

          return Boolean(i && a);
        }, t.isDeletingEntityRecord = function isDeletingEntityRecord(e, t, r, n) {
          return (0, s.get)(e.entities.data, [t, r, "deleting", n, "pending"], !1);
        }, t.isPreviewEmbedFallback = function isPreviewEmbedFallback(e, t) {
          var r = e.embedPreviews[t],
              n = '<a href="' + t + '">' + t + "</a>";
          if (!r) return !1;
          return r.html === n;
        }, t.isRequestingEmbedPreview = void 0, t.isSavingEntityRecord = isSavingEntityRecord;
        var i = n(r(235)),
            s = r(793),
            a = r(467),
            o = r(904),
            u = n(r(703)),
            d = r(971),
            l = r(366),
            c = r(85),
            p = r(785);
        var v = {},
            y = [],
            E = (0, a.createRegistrySelector)(function (e) {
          return function (t, r) {
            return e(d.STORE_NAME).isResolving("getEmbedPreview", [r]);
          };
        });
        t.isRequestingEmbedPreview = E;
        var m = (0, i.default)(function (e, t) {
          var r = e.users.queries[t];
          return (0, s.map)(r, function (t) {
            return e.users.byId[t];
          });
        }, function (e, t) {
          return [e.users.queries[t], e.users.byId];
        });

        function getEntity(e, t, r) {
          return (0, s.find)(e.entities.config, {
            kind: t,
            name: r
          });
        }

        t.getUserQueryResults = m;
        var g = (0, i.default)(function (e, t, r, n, i) {
          var a, o;
          var u = (0, s.get)(e.entities.data, [t, r, "queriedData"]);
          if (!u) return;
          var d = null !== (a = null == i ? void 0 : i.context) && void 0 !== a ? a : "default";

          if (void 0 === i) {
            var l;
            if (null === (l = u.itemIsComplete[d]) || void 0 === l || !l[n]) return;
            return u.items[d][n];
          }

          var c = null === (o = u.items[d]) || void 0 === o ? void 0 : o[n];

          if (c && i._fields) {
            var _e15 = {},
                _t9 = (0, p.getNormalizedCommaSeparable)(i._fields);

            for (var _r19 = 0; _r19 < _t9.length; _r19++) {
              var _n17 = _t9[_r19].split("."),
                  _i10 = (0, s.get)(c, _n17);

              (0, s.set)(_e15, _n17, _i10);
            }

            return _e15;
          }

          return c;
        }, function (e, t, r, n, i) {
          var a;
          var o = null !== (a = null == i ? void 0 : i.context) && void 0 !== a ? a : "default";
          return [(0, s.get)(e.entities.data, [t, r, "queriedData", "items", o, n]), (0, s.get)(e.entities.data, [t, r, "queriedData", "itemIsComplete", o, n])];
        });
        t.getEntityRecord = g;
        var h = (0, i.default)(function (e, t, r, n) {
          var i = g(e, t, r, n);
          return i && Object.keys(i).reduce(function (n, a) {
            return (0, p.isRawAttribute)(getEntity(e, t, r), a) ? n[a] = (0, s.get)(i[a], "raw", i[a]) : n[a] = i[a], n;
          }, {});
        }, function (e, t, r, n, i) {
          var a;
          var o = null !== (a = null == i ? void 0 : i.context) && void 0 !== a ? a : "default";
          return [e.entities.config, (0, s.get)(e.entities.data, [t, r, "queriedData", "items", o, n]), (0, s.get)(e.entities.data, [t, r, "queriedData", "itemIsComplete", o, n])];
        });

        function getEntityRecords(e, t, r, n) {
          var i = (0, s.get)(e.entities.data, [t, r, "queriedData"]);
          return i ? (0, l.getQueriedItems)(i, n) : y;
        }

        t.getRawEntityRecord = h;

        var _ = (0, i.default)(function (e) {
          var t = e.entities.data,
              r = [];
          return Object.keys(t).forEach(function (n) {
            Object.keys(t[n]).forEach(function (i) {
              var s = Object.keys(t[n][i].edits).filter(function (t) {
                return g(e, n, i, t) && hasEditsForEntityRecord(e, n, i, t);
              });

              if (s.length) {
                var _t10 = getEntity(e, n, i);

                s.forEach(function (s) {
                  var a;
                  var o = T(e, n, i, s);
                  r.push({
                    key: o[_t10.key || c.DEFAULT_ENTITY_KEY],
                    title: (null == _t10 || null === (a = _t10.getTitle) || void 0 === a ? void 0 : a.call(_t10, o)) || "",
                    name: i,
                    kind: n
                  });
                });
              }
            });
          }), r;
        }, function (e) {
          return [e.entities.data];
        });

        t.__experimentalGetDirtyEntityRecords = _;
        var b = (0, i.default)(function (e) {
          var t = e.entities.data,
              r = [];
          return Object.keys(t).forEach(function (n) {
            Object.keys(t[n]).forEach(function (i) {
              var s = Object.keys(t[n][i].saving).filter(function (t) {
                return isSavingEntityRecord(e, n, i, t);
              });

              if (s.length) {
                var _t11 = getEntity(e, n, i);

                s.forEach(function (s) {
                  var a;
                  var o = T(e, n, i, s);
                  r.push({
                    key: o[_t11.key || c.DEFAULT_ENTITY_KEY],
                    title: (null == _t11 || null === (a = _t11.getTitle) || void 0 === a ? void 0 : a.call(_t11, o)) || "",
                    name: i,
                    kind: n
                  });
                });
              }
            });
          }), r;
        }, function (e) {
          return [e.entities.data];
        });

        function getEntityRecordEdits(e, t, r, n) {
          return (0, s.get)(e.entities.data, [t, r, "edits", n]);
        }

        t.__experimentalGetEntitiesBeingSaved = b;
        var R = (0, i.default)(function (e, t, r, n) {
          var _ref32 = getEntity(e, t, r) || {},
              i = _ref32.transientEdits,
              s = getEntityRecordEdits(e, t, r, n) || {};

          return i ? Object.keys(s).reduce(function (e, t) {
            return i[t] || (e[t] = s[t]), e;
          }, {}) : s;
        }, function (e, t, r, n) {
          return [e.entities.config, (0, s.get)(e.entities.data, [t, r, "edits", n])];
        });

        function hasEditsForEntityRecord(e, t, r, n) {
          return isSavingEntityRecord(e, t, r, n) || Object.keys(R(e, t, r, n)).length > 0;
        }

        t.getEntityRecordNonTransientEdits = R;
        var T = (0, i.default)(function (e, t, r, n) {
          return _objectSpread(_objectSpread({}, h(e, t, r, n)), getEntityRecordEdits(e, t, r, n));
        }, function (e, t, r, n, i) {
          var a;
          var o = null !== (a = null == i ? void 0 : i.context) && void 0 !== a ? a : "default";
          return [e.entities.config, (0, s.get)(e.entities.data, [t, r, "queriedData", "items", o, n]), (0, s.get)(e.entities.data, [t, r, "queriedData", "itemIsComplete", o, n]), (0, s.get)(e.entities.data, [t, r, "edits", n])];
        });

        function isSavingEntityRecord(e, t, r, n) {
          return (0, s.get)(e.entities.data, [t, r, "saving", n, "pending"], !1);
        }

        function getCurrentUndoOffset(e) {
          return e.undo.offset;
        }

        function getUndoEdit(e) {
          return e.undo[e.undo.length - 2 + getCurrentUndoOffset(e)];
        }

        function getRedoEdit(e) {
          return e.undo[e.undo.length + getCurrentUndoOffset(e)];
        }

        function getCurrentTheme(e) {
          return g(e, "root", "theme", e.currentTheme);
        }

        function canUser(e, t, r, n) {
          var i = (0, s.compact)([t, r, n]).join("/");
          return (0, s.get)(e, ["userPermissions", i]);
        }

        t.getEditedEntityRecord = T;
        var w = (0, a.createRegistrySelector)(function (e) {
          return function (t, r, n) {
            return e(d.STORE_NAME).hasFinishedResolution("getAutosaves", [r, n]);
          };
        });
        t.hasFetchedAutosaves = w;
        var k = (0, i.default)(function () {
          return [];
        }, function (e) {
          return [e.undo.length, e.undo.offset, e.undo.flattenedUndo];
        });
        t.getReferenceByDistinctEdits = k;
      },
      278: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function conservativeMapItem(e, t) {
          if (!e) return t;
          var r = !1;
          var i = {};

          for (var s in t) {
            (0, n.isEqual)(e[s], t[s]) ? i[s] = e[s] : (r = !0, i[s] = t[s]);
          }

          if (!r) return e;

          for (var _t12 in e) {
            i.hasOwnProperty(_t12) || (i[_t12] = e[_t12]);
          }

          return i;
        };
        var n = r(793);
      },
      522: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var _default = function _default(e) {
          return function () {
            for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
              r[n] = arguments[n];
            }

            return /*#__PURE__*/function () {
              var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t) {
                var n;
                return _regeneratorRuntime.wrap(function _callee26$(_context28) {
                  while (1) {
                    switch (_context28.prev = _context28.next) {
                      case 0:
                        n = t.resolveSelect;
                        _context28.next = 3;
                        return n[e].apply(n, r);

                      case 3:
                      case "end":
                        return _context28.stop();
                    }
                  }
                }, _callee26);
              }));

              return function (_x23) {
                return _ref33.apply(this, arguments);
              };
            }();
          };
        };

        t.default = _default;
      },
      981: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var r = function getNormalizedCommaSeparable(e) {
          return "string" == typeof e ? e.split(",") : Array.isArray(e) ? e : null;
        };

        t.default = r;
      },
      452: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var _default = function _default(e) {
          return function (t) {
            return function (r, n) {
              return void 0 === r || e(n) ? t(r, n) : r;
            };
          };
        };

        t.default = _default;
      },
      785: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "conservativeMapItem", {
          enumerable: !0,
          get: function get() {
            return i.default;
          }
        }), Object.defineProperty(t, "forwardResolver", {
          enumerable: !0,
          get: function get() {
            return o.default;
          }
        }), Object.defineProperty(t, "getNormalizedCommaSeparable", {
          enumerable: !0,
          get: function get() {
            return s.default;
          }
        }), Object.defineProperty(t, "ifMatchingAction", {
          enumerable: !0,
          get: function get() {
            return a.default;
          }
        }), Object.defineProperty(t, "isRawAttribute", {
          enumerable: !0,
          get: function get() {
            return c.default;
          }
        }), Object.defineProperty(t, "onSubKey", {
          enumerable: !0,
          get: function get() {
            return u.default;
          }
        }), Object.defineProperty(t, "replaceAction", {
          enumerable: !0,
          get: function get() {
            return d.default;
          }
        }), Object.defineProperty(t, "withWeakMapCache", {
          enumerable: !0,
          get: function get() {
            return l.default;
          }
        });
        var i = n(r(278)),
            s = n(r(981)),
            a = n(r(452)),
            o = n(r(522)),
            u = n(r(334)),
            d = n(r(142)),
            l = n(r(103)),
            c = n(r(151));
      },
      151: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function isRawAttribute(e, t) {
          return (e.rawAttributes || []).includes(t);
        };
      },
      334: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.onSubKey = t.default = void 0;

        var onSubKey = function onSubKey(e) {
          return function (t) {
            return function () {
              var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  n = arguments.length > 1 ? arguments[1] : void 0;
              var i = n[e];
              if (void 0 === i) return r;
              var s = t(r[i], n);
              return s === r[i] ? r : _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, i, s));
            };
          };
        };

        t.onSubKey = onSubKey;
        var r = onSubKey;
        t.default = r;
      },
      142: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;

        var _default = function _default(e) {
          return function (t) {
            return function (r, n) {
              return t(r, e(n));
            };
          };
        };

        t.default = _default;
      },
      103: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = r(793);

        var i = function withWeakMapCache(e) {
          var t = new WeakMap();
          return function (r) {
            var i;
            return t.has(r) ? i = t.get(r) : (i = e(r), (0, n.isObjectLike)(r) && t.set(r, i)), i;
          };
        };

        t.default = i;
      },
      820: function _(e) {
        "use strict";

        function _typeof(e) {
          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, _typeof(e);
        }

        function _defineProperties(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        function getValuePair(e, t) {
          var r = e._map,
              n = e._arrayTreeMap,
              i = e._objectTreeMap;
          if (r.has(t)) return r.get(t);

          for (var s = Object.keys(t).sort(), a = Array.isArray(t) ? n : i, o = 0; o < s.length; o++) {
            var u = s[o];
            if (void 0 === (a = a.get(u))) return;
            var d = t[u];
            if (void 0 === (a = a.get(d))) return;
          }

          var l = a.get("_ekm_value");
          return l ? (r.delete(l[0]), l[0] = t, a.set("_ekm_value", l), r.set(t, l), l) : void 0;
        }

        var t = function () {
          function EquivalentKeyMap(e) {
            if (function _classCallCheck(e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, EquivalentKeyMap), this.clear(), e instanceof EquivalentKeyMap) {
              var t = [];
              e.forEach(function (e, r) {
                t.push([r, e]);
              }), e = t;
            }

            if (null != e) for (var r = 0; r < e.length; r++) {
              this.set(e[r][0], e[r][1]);
            }
          }

          return function _createClass(e, t, r) {
            return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
          }(EquivalentKeyMap, [{
            key: "set",
            value: function set(e, t) {
              if (null === e || "object" !== _typeof(e)) return this._map.set(e, t), this;

              for (var r = Object.keys(e).sort(), n = [e, t], i = Array.isArray(e) ? this._arrayTreeMap : this._objectTreeMap, s = 0; s < r.length; s++) {
                var a = r[s];
                i.has(a) || i.set(a, new EquivalentKeyMap()), i = i.get(a);
                var o = e[a];
                i.has(o) || i.set(o, new EquivalentKeyMap()), i = i.get(o);
              }

              var u = i.get("_ekm_value");
              return u && this._map.delete(u[0]), i.set("_ekm_value", n), this._map.set(e, n), this;
            }
          }, {
            key: "get",
            value: function get(e) {
              if (null === e || "object" !== _typeof(e)) return this._map.get(e);
              var t = getValuePair(this, e);
              return t ? t[1] : void 0;
            }
          }, {
            key: "has",
            value: function has(e) {
              return null === e || "object" !== _typeof(e) ? this._map.has(e) : void 0 !== getValuePair(this, e);
            }
          }, {
            key: "delete",
            value: function _delete(e) {
              return !!this.has(e) && (this.set(e, void 0), !0);
            }
          }, {
            key: "forEach",
            value: function forEach(e) {
              var t = this,
                  r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this;

              this._map.forEach(function (n, i) {
                null !== i && "object" === _typeof(i) && (n = n[1]), e.call(r, n, i, t);
              });
            }
          }, {
            key: "clear",
            value: function clear() {
              this._map = new Map(), this._arrayTreeMap = new Map(), this._objectTreeMap = new Map();
            }
          }, {
            key: "size",
            get: function get() {
              return this._map.size;
            }
          }]), EquivalentKeyMap;
        }();

        e.exports = t;
      },
      235: function _(e, t, r) {
        "use strict";

        var n, i;

        function arrayOf(e) {
          return [e];
        }

        function createCache() {
          var e = {
            clear: function clear() {
              e.head = null;
            }
          };
          return e;
        }

        function isShallowEqual(e, t, r) {
          var n;
          if (e.length !== t.length) return !1;

          for (n = r; n < e.length; n++) {
            if (e[n] !== t[n]) return !1;
          }

          return !0;
        }

        function __WEBPACK_DEFAULT_EXPORT__(e, t) {
          var r, s;

          function clear() {
            r = i ? new WeakMap() : createCache();
          }

          function callSelector() {
            var r,
                n,
                i,
                a,
                o,
                u = arguments.length;

            for (a = new Array(u), i = 0; i < u; i++) {
              a[i] = arguments[i];
            }

            for (o = t.apply(null, a), (r = s(o)).isUniqueByDependants || (r.lastDependants && !isShallowEqual(o, r.lastDependants, 0) && r.clear(), r.lastDependants = o), n = r.head; n;) {
              if (isShallowEqual(n.args, a, 1)) return n !== r.head && (n.prev.next = n.next, n.next && (n.next.prev = n.prev), n.next = r.head, n.prev = null, r.head.prev = n, r.head = n), n.val;
              n = n.next;
            }

            return n = {
              val: e.apply(null, a)
            }, a[0] = null, n.args = a, r.head && (r.head.prev = n, n.next = r.head), r.head = n, n.val;
          }

          return t || (t = arrayOf), s = i ? function getWeakMapCache(e) {
            var t,
                i,
                s,
                a,
                o,
                u = r,
                d = !0;

            for (t = 0; t < e.length; t++) {
              if (i = e[t], !(o = i) || "object" != typeof o) {
                d = !1;
                break;
              }

              u.has(i) ? u = u.get(i) : (s = new WeakMap(), u.set(i, s), u = s);
            }

            return u.has(n) || ((a = createCache()).isUniqueByDependants = d, u.set(n, a)), u.get(n);
          } : function getRootCache() {
            return r;
          }, callSelector.getDependants = t, callSelector.clear = clear, clear(), callSelector;
        }

        r.r(t), r.d(t, {
          default: function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
        }), n = {}, i = "undefined" != typeof WeakMap;
      },
      233: function _(e, t, r) {
        "use strict";

        var n;
        r.r(t), r.d(t, {
          NIL: function NIL() {
            return R;
          },
          parse: function parse() {
            return E;
          },
          stringify: function stringify() {
            return d;
          },
          v1: function v1() {
            return y;
          },
          v3: function v3() {
            return g;
          },
          v4: function v4() {
            return h;
          },
          v5: function v5() {
            return b;
          },
          validate: function validate() {
            return a;
          },
          version: function version() {
            return T;
          }
        });
        var i = new Uint8Array(16);

        function rng() {
          if (!n && !(n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
          return n(i);
        }

        var s = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

        var a = function validate(e) {
          return "string" == typeof e && s.test(e);
        };

        for (var o = [], u = 0; u < 256; ++u) {
          o.push((u + 256).toString(16).substr(1));
        }

        var d = function stringify(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              r = (o[e[t + 0]] + o[e[t + 1]] + o[e[t + 2]] + o[e[t + 3]] + "-" + o[e[t + 4]] + o[e[t + 5]] + "-" + o[e[t + 6]] + o[e[t + 7]] + "-" + o[e[t + 8]] + o[e[t + 9]] + "-" + o[e[t + 10]] + o[e[t + 11]] + o[e[t + 12]] + o[e[t + 13]] + o[e[t + 14]] + o[e[t + 15]]).toLowerCase();
          if (!a(r)) throw TypeError("Stringified UUID is invalid");
          return r;
        };

        var l,
            c,
            p = 0,
            v = 0;

        var y = function v1(e, t, r) {
          var n = t && r || 0,
              i = t || new Array(16),
              s = (e = e || {}).node || l,
              a = void 0 !== e.clockseq ? e.clockseq : c;

          if (null == s || null == a) {
            var o = e.random || (e.rng || rng)();
            null == s && (s = l = [1 | o[0], o[1], o[2], o[3], o[4], o[5]]), null == a && (a = c = 16383 & (o[6] << 8 | o[7]));
          }

          var u = void 0 !== e.msecs ? e.msecs : Date.now(),
              y = void 0 !== e.nsecs ? e.nsecs : v + 1,
              E = u - p + (y - v) / 1e4;
          if (E < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (E < 0 || u > p) && void 0 === e.nsecs && (y = 0), y >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          p = u, v = y, c = a;
          var m = (1e4 * (268435455 & (u += 122192928e5)) + y) % 4294967296;
          i[n++] = m >>> 24 & 255, i[n++] = m >>> 16 & 255, i[n++] = m >>> 8 & 255, i[n++] = 255 & m;
          var g = u / 4294967296 * 1e4 & 268435455;
          i[n++] = g >>> 8 & 255, i[n++] = 255 & g, i[n++] = g >>> 24 & 15 | 16, i[n++] = g >>> 16 & 255, i[n++] = a >>> 8 | 128, i[n++] = 255 & a;

          for (var h = 0; h < 6; ++h) {
            i[n + h] = s[h];
          }

          return t || d(i);
        };

        var E = function parse(e) {
          if (!a(e)) throw TypeError("Invalid UUID");
          var t,
              r = new Uint8Array(16);
          return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
        };

        function v35(e, t, r) {
          function generateUUID(e, n, i, s) {
            if ("string" == typeof e && (e = function stringToBytes(e) {
              e = unescape(encodeURIComponent(e));

              for (var t = [], r = 0; r < e.length; ++r) {
                t.push(e.charCodeAt(r));
              }

              return t;
            }(e)), "string" == typeof n && (n = E(n)), 16 !== n.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
            var a = new Uint8Array(16 + e.length);

            if (a.set(n), a.set(e, n.length), (a = r(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, i) {
              s = s || 0;

              for (var o = 0; o < 16; ++o) {
                i[s + o] = a[o];
              }

              return i;
            }

            return d(a);
          }

          try {
            generateUUID.name = e;
          } catch (e) {}

          return generateUUID.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", generateUUID.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", generateUUID;
        }

        function getOutputLength(e) {
          return 14 + (e + 64 >>> 9 << 4) + 1;
        }

        function safeAdd(e, t) {
          var r = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
        }

        function md5cmn(e, t, r, n, i, s) {
          return safeAdd(function bitRotateLeft(e, t) {
            return e << t | e >>> 32 - t;
          }(safeAdd(safeAdd(t, e), safeAdd(n, s)), i), r);
        }

        function md5ff(e, t, r, n, i, s, a) {
          return md5cmn(t & r | ~t & n, e, t, i, s, a);
        }

        function md5gg(e, t, r, n, i, s, a) {
          return md5cmn(t & n | r & ~n, e, t, i, s, a);
        }

        function md5hh(e, t, r, n, i, s, a) {
          return md5cmn(t ^ r ^ n, e, t, i, s, a);
        }

        function md5ii(e, t, r, n, i, s, a) {
          return md5cmn(r ^ (t | ~n), e, t, i, s, a);
        }

        var m = function md5(e) {
          if ("string" == typeof e) {
            var t = unescape(encodeURIComponent(e));
            e = new Uint8Array(t.length);

            for (var r = 0; r < t.length; ++r) {
              e[r] = t.charCodeAt(r);
            }
          }

          return function md5ToHexEncodedArray(e) {
            for (var t = [], r = 32 * e.length, n = "0123456789abcdef", i = 0; i < r; i += 8) {
              var s = e[i >> 5] >>> i % 32 & 255,
                  a = parseInt(n.charAt(s >>> 4 & 15) + n.charAt(15 & s), 16);
              t.push(a);
            }

            return t;
          }(function wordsToMd5(e, t) {
            e[t >> 5] |= 128 << t % 32, e[getOutputLength(t) - 1] = t;

            for (var r = 1732584193, n = -271733879, i = -1732584194, s = 271733878, a = 0; a < e.length; a += 16) {
              var o = r,
                  u = n,
                  d = i,
                  l = s;
              r = md5ff(r, n, i, s, e[a], 7, -680876936), s = md5ff(s, r, n, i, e[a + 1], 12, -389564586), i = md5ff(i, s, r, n, e[a + 2], 17, 606105819), n = md5ff(n, i, s, r, e[a + 3], 22, -1044525330), r = md5ff(r, n, i, s, e[a + 4], 7, -176418897), s = md5ff(s, r, n, i, e[a + 5], 12, 1200080426), i = md5ff(i, s, r, n, e[a + 6], 17, -1473231341), n = md5ff(n, i, s, r, e[a + 7], 22, -45705983), r = md5ff(r, n, i, s, e[a + 8], 7, 1770035416), s = md5ff(s, r, n, i, e[a + 9], 12, -1958414417), i = md5ff(i, s, r, n, e[a + 10], 17, -42063), n = md5ff(n, i, s, r, e[a + 11], 22, -1990404162), r = md5ff(r, n, i, s, e[a + 12], 7, 1804603682), s = md5ff(s, r, n, i, e[a + 13], 12, -40341101), i = md5ff(i, s, r, n, e[a + 14], 17, -1502002290), r = md5gg(r, n = md5ff(n, i, s, r, e[a + 15], 22, 1236535329), i, s, e[a + 1], 5, -165796510), s = md5gg(s, r, n, i, e[a + 6], 9, -1069501632), i = md5gg(i, s, r, n, e[a + 11], 14, 643717713), n = md5gg(n, i, s, r, e[a], 20, -373897302), r = md5gg(r, n, i, s, e[a + 5], 5, -701558691), s = md5gg(s, r, n, i, e[a + 10], 9, 38016083), i = md5gg(i, s, r, n, e[a + 15], 14, -660478335), n = md5gg(n, i, s, r, e[a + 4], 20, -405537848), r = md5gg(r, n, i, s, e[a + 9], 5, 568446438), s = md5gg(s, r, n, i, e[a + 14], 9, -1019803690), i = md5gg(i, s, r, n, e[a + 3], 14, -187363961), n = md5gg(n, i, s, r, e[a + 8], 20, 1163531501), r = md5gg(r, n, i, s, e[a + 13], 5, -1444681467), s = md5gg(s, r, n, i, e[a + 2], 9, -51403784), i = md5gg(i, s, r, n, e[a + 7], 14, 1735328473), r = md5hh(r, n = md5gg(n, i, s, r, e[a + 12], 20, -1926607734), i, s, e[a + 5], 4, -378558), s = md5hh(s, r, n, i, e[a + 8], 11, -2022574463), i = md5hh(i, s, r, n, e[a + 11], 16, 1839030562), n = md5hh(n, i, s, r, e[a + 14], 23, -35309556), r = md5hh(r, n, i, s, e[a + 1], 4, -1530992060), s = md5hh(s, r, n, i, e[a + 4], 11, 1272893353), i = md5hh(i, s, r, n, e[a + 7], 16, -155497632), n = md5hh(n, i, s, r, e[a + 10], 23, -1094730640), r = md5hh(r, n, i, s, e[a + 13], 4, 681279174), s = md5hh(s, r, n, i, e[a], 11, -358537222), i = md5hh(i, s, r, n, e[a + 3], 16, -722521979), n = md5hh(n, i, s, r, e[a + 6], 23, 76029189), r = md5hh(r, n, i, s, e[a + 9], 4, -640364487), s = md5hh(s, r, n, i, e[a + 12], 11, -421815835), i = md5hh(i, s, r, n, e[a + 15], 16, 530742520), r = md5ii(r, n = md5hh(n, i, s, r, e[a + 2], 23, -995338651), i, s, e[a], 6, -198630844), s = md5ii(s, r, n, i, e[a + 7], 10, 1126891415), i = md5ii(i, s, r, n, e[a + 14], 15, -1416354905), n = md5ii(n, i, s, r, e[a + 5], 21, -57434055), r = md5ii(r, n, i, s, e[a + 12], 6, 1700485571), s = md5ii(s, r, n, i, e[a + 3], 10, -1894986606), i = md5ii(i, s, r, n, e[a + 10], 15, -1051523), n = md5ii(n, i, s, r, e[a + 1], 21, -2054922799), r = md5ii(r, n, i, s, e[a + 8], 6, 1873313359), s = md5ii(s, r, n, i, e[a + 15], 10, -30611744), i = md5ii(i, s, r, n, e[a + 6], 15, -1560198380), n = md5ii(n, i, s, r, e[a + 13], 21, 1309151649), r = md5ii(r, n, i, s, e[a + 4], 6, -145523070), s = md5ii(s, r, n, i, e[a + 11], 10, -1120210379), i = md5ii(i, s, r, n, e[a + 2], 15, 718787259), n = md5ii(n, i, s, r, e[a + 9], 21, -343485551), r = safeAdd(r, o), n = safeAdd(n, u), i = safeAdd(i, d), s = safeAdd(s, l);
            }

            return [r, n, i, s];
          }(function bytesToWords(e) {
            if (0 === e.length) return [];

            for (var t = 8 * e.length, r = new Uint32Array(getOutputLength(t)), n = 0; n < t; n += 8) {
              r[n >> 5] |= (255 & e[n / 8]) << n % 32;
            }

            return r;
          }(e), 8 * e.length));
        };

        var g = v35("v3", 48, m);

        var h = function v4(e, t, r) {
          var n = (e = e || {}).random || (e.rng || rng)();

          if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, t) {
            r = r || 0;

            for (var i = 0; i < 16; ++i) {
              t[r + i] = n[i];
            }

            return t;
          }

          return d(n);
        };

        function f(e, t, r, n) {
          switch (e) {
            case 0:
              return t & r ^ ~t & n;

            case 1:
            case 3:
              return t ^ r ^ n;

            case 2:
              return t & r ^ t & n ^ r & n;
          }
        }

        function ROTL(e, t) {
          return e << t | e >>> 32 - t;
        }

        var _ = function sha1(e) {
          var t = [1518500249, 1859775393, 2400959708, 3395469782],
              r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];

          if ("string" == typeof e) {
            var n = unescape(encodeURIComponent(e));
            e = [];

            for (var i = 0; i < n.length; ++i) {
              e.push(n.charCodeAt(i));
            }
          } else Array.isArray(e) || (e = Array.prototype.slice.call(e));

          e.push(128);

          for (var s = e.length / 4 + 2, a = Math.ceil(s / 16), o = new Array(a), u = 0; u < a; ++u) {
            for (var d = new Uint32Array(16), l = 0; l < 16; ++l) {
              d[l] = e[64 * u + 4 * l] << 24 | e[64 * u + 4 * l + 1] << 16 | e[64 * u + 4 * l + 2] << 8 | e[64 * u + 4 * l + 3];
            }

            o[u] = d;
          }

          o[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), o[a - 1][14] = Math.floor(o[a - 1][14]), o[a - 1][15] = 8 * (e.length - 1) & 4294967295;

          for (var c = 0; c < a; ++c) {
            for (var p = new Uint32Array(80), v = 0; v < 16; ++v) {
              p[v] = o[c][v];
            }

            for (var y = 16; y < 80; ++y) {
              p[y] = ROTL(p[y - 3] ^ p[y - 8] ^ p[y - 14] ^ p[y - 16], 1);
            }

            for (var E = r[0], m = r[1], g = r[2], h = r[3], _ = r[4], b = 0; b < 80; ++b) {
              var R = Math.floor(b / 20),
                  T = ROTL(E, 5) + f(R, m, g, h) + _ + t[R] + p[b] >>> 0;
              _ = h, h = g, g = ROTL(m, 30) >>> 0, m = E, E = T;
            }

            r[0] = r[0] + E >>> 0, r[1] = r[1] + m >>> 0, r[2] = r[2] + g >>> 0, r[3] = r[3] + h >>> 0, r[4] = r[4] + _ >>> 0;
          }

          return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
        };

        var b = v35("v5", 80, _),
            R = "00000000-0000-0000-0000-000000000000";

        var T = function version(e) {
          if (!a(e)) throw TypeError("Invalid UUID");
          return parseInt(e.substr(14, 1), 16);
        };
      },
      507: function _(e) {
        "use strict";

        e.exports = require("@wordpress/api-fetch");
      },
      700: function _(e) {
        "use strict";

        e.exports = require("@wordpress/blocks");
      },
      467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      703: function _(e) {
        "use strict";

        e.exports = require("@wordpress/deprecated");
      },
      753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      248: function _(e) {
        "use strict";

        e.exports = require("@wordpress/html-entities");
      },
      756: function _(e) {
        "use strict";

        e.exports = require("@wordpress/i18n");
      },
      626: function _(e) {
        "use strict";

        e.exports = require("@wordpress/is-shallow-equal");
      },
      904: function _(e) {
        "use strict";

        e.exports = require("@wordpress/url");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r](i, i.exports, __webpack_require__), i.exports;
    }

    return __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__(349);
  }();
});